import { vnTemplate } from '../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate';
import { filterDropdown_template } from '../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/filterDropdown_template';
import { filterSingle_multiLevel_selector_template } from '../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/filterSingle_multiLevel_selector_template';
import { filterDate_template } from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/filterDate_template";
import {multipleSelector_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/multipleSelector_template";
import {filterMultipleAutoComplete_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/filterMultipleAutoComplete_template";
import {filterSimple_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/filterSimple_template";
import * as am4charts from "@amcharts/amcharts4/charts";
import * as am4core from "@amcharts/amcharts4/core";
import {amCharts_v4_date_basic_template} from "./amCharts_v4_date_basic_template";
import {presetFilter_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/presetFilter_template";
import {exportDataCsv} from "../../../vendor/valnet/valnet_jslib/vnHelpers/exportDataCsv";
import {resultsInfo_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/resultsInfo_template";
import {pagination_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/pagination_template";
import {infoButton_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/infoButton_template";
import { vnApp_sentinelbi } from '../vnApp_sentinelbi';

declare var ko: any;


export class audienceOverview_template extends vnTemplate {

    protected viewsChart: amCharts_v4_date_basic_template;
    protected brandFilter: filterSingle_multiLevel_selector_template;
    protected dateRangeFilter: filterDate_template;
    protected compRangeFilter: filterDate_template;
    protected viewModeFilter: filterDropdown_template;
    protected multiSegmentsFilter : multipleSelector_template;
    protected segmentsFilter : filterDropdown_template;
    protected presetFilter: presetFilter_template;
    protected exportDataCsv: exportDataCsv;
    protected resultsInfo: resultsInfo_template;
    protected compareFilter: filterSingle_multiLevel_selector_template;
    protected graphMetricFilter: filterSingle_multiLevel_selector_template;
    protected tableMetricFilter: filterSingle_multiLevel_selector_template;
    protected pagination: pagination_template;
    protected annotationTooltip: infoButton_template;

    private readonly hourlyNetworkMaxMonthsInRange = 3;
    private readonly hourlyNonNetworkMaxMonthsInRange = 6;
    private readonly dailyNetworkMaxMonthsInRange = 6;
    private readonly dailyNonNetworkMaxMonthsInRange = 12;
    private readonly monthlyMaxMonthsInRange = 24;

    readonly graphMetrics = [
        {"id": "views", "name": "Views"},
        {"id": "visits", "name": "Visits"},
        {"id": "sessions", "name": "Sessions"},
    ];

    readonly tableMetrics = [
        {"id": "traffic", "name": "Traffic"},
        {"id": "brands", "name": "Properties"},
    ];

    /**
     * @inheritDoc
     */
    protected getTemplateHtml(): string{

        return `

        <div style="display: none;">
            ` + this.multiSegmentsFilter.getHtmlBuild() + `
        </div>
        <div style="display: none;">
            <label class="form-label">View Mode</label>
                ${this.viewModeFilter.getHtmlBuild()}
        </div>
        <div style="display: none;">
            <label class="form-label">Segment</label>
            ` + this.segmentsFilter.getHtmlBuild() + `
        </div>

            <div id="report-results">

                <div class="page-header">
                    <h2 class="title-page">Audience Overview</h2>

                    <div data-bind="if: reportStatusData()" class="report-status">
                        <div class="button-default"
                            data-bind="css: {
                                'status-ok': reportStatusData().status === 'LIVE',
                                'status-delayed': reportStatusData().status === 'DELAYED',
                                'status-error': reportStatusData().status === 'ERRORS'
                            }">
                            <span data-bind="css: {
                                'icon i-live': reportStatusData().status === 'LIVE'
                            }"></span>

                            <div class="status" data-bind="text: reportStatusData().status"></div>

                            <div data-bind="if: reportStatusData().status === 'DELAYED' || reportStatusData().status === 'ERRORS'">
                                <div class="report-status-tooltip">
                                    <p style="text-transform: none;" data-bind="html: reportStatusData().message"></p>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>


                <div class="w-justify block-filters filters-responsive">
                    <div class="w-left flex-none sidebar-filters-js-only" >
                        <button data-bind="event: { click: onSidebarToggle }" class="button-default no-text icon i-preferences preferences no-after" type="button" title="report preferences">
                            <span class="hide-text">REPORT PREFERENCES</span>
                        </button>
                        <nav class="sidebar-default" data-bind="css: {'is-open': sidebarToggle()}">
                            <div class="sidebar-default-header">
                                <span class="label-default sidebar-default-header icon i-preferences">Report Preferences</span>
                                <button data-bind="event: { click: onSidebarToggle }" type="button" class="btn-close-default icon i-close"><span></span></button>
                            </div>

                            <div class="sidebar-default-body">
                                <div>
                                    <span class="label-default icon i-intervals">Interval</span>
                                    <ul class="sidebar-default-list">
                                        <li>
                                            <label class="label-checkbox-menu-default" data-bind="css: {'is-disabled': isTimeGroupDisabled('hourly')}, attr: {title: getTimeGroupTitle('hourly', 'Hourly')}">
                                                <span>Hourly</span>
                                                <input type="radio" id="radio-hourly" name="switch-time-group" value="hourly" data-bind="event: {change: onTimeGroupSwitch.bind($data, 'hourly')}, checked: timeGroupSwitch, disable: isTimeGroupDisabled('hourly')"/>
                                            </label>
                                        </li>
                                        <li>
                                            <label class="label-checkbox-menu-default" data-bind="css: {'is-disabled': isTimeGroupDisabled('daily')}, attr: {title: getTimeGroupTitle('daily', 'Daily')}">
                                                <span>Daily</span>
                                                <input type="radio" id="radio-daily" name="switch-time-group" value="daily" data-bind="event: {change: onTimeGroupSwitch.bind($data, 'daily')}, checked: timeGroupSwitch, disable: isTimeGroupDisabled('daily')"/>
                                            </label>
                                        </li>
                                        <li>
                                            <label class="label-checkbox-menu-default" data-bind="css: {'is-disabled': isTimeGroupDisabled('weekly')}, attr: {title: getTimeGroupTitle('weekly', 'Weekly')}">
                                                <span>Weekly</span>
                                                <input type="radio" id="radio-weekly" name="switch-time-group" value="weekly" data-bind="event: {change: onTimeGroupSwitch.bind($data, 'weekly')}, checked: timeGroupSwitch, disable: isTimeGroupDisabled('weekly')"/>
                                            </label>
                                        </li>
                                        <li>
                                            <label class="label-checkbox-menu-default" data-bind="css: {'is-disabled': isTimeGroupDisabled('monthly')}, attr: {title: getTimeGroupTitle('monthly', 'Monthly')}">
                                                <span>Monthly</span>
                                                <input type="radio" id="radio-monthly" name="switch-time-group" value="monthly" data-bind="event: {change: onTimeGroupSwitch.bind($data, 'monthly')}, checked: timeGroupSwitch, disable: isTimeGroupDisabled('monthly')"/>
                                            </label>
                                        </li>
                                    </ul>
                                </div>
                                <div>
                                    <span class="label-default icon i-dimensions">Dimensions</span>
                                    <ul class="sidebar-default-list">
                                        <li>
                                            <label class="label-checkbox-menu-default" title="Default">
                                                <span>Default</span>
                                                <input type="radio" id="radio-dimension-time" name="switch-dimension-group" value="time" data-bind="event: {change: onDimensionGroupSwitch.bind($data, 'time')}, checked: dimensionGroupSwitch"/>
                                            </label>
                                        </li>
                                        <li>
                                            <label class="label-checkbox-menu-default" title="Device">
                                                <span>Device</span>
                                                <input type="radio" id="radio-dimension-device" name="switch-dimension-device" value="device" data-bind="event: {change: onDimensionGroupSwitch.bind($data, 'device')}, checked: dimensionGroupSwitch"/>
                                            </label>
                                        </li>
                                        <li>
                                            <label class="label-checkbox-menu-default" title="Traffic Classification">
                                                <span>Traffic Classification</span>
                                                <input type="radio" id="radio-dimension-trafficClassification" name="switch-dimension-trafficClassification" value="trafficClassification" data-bind="event: {change: onDimensionGroupSwitch.bind($data, 'trafficClassification')}, checked: dimensionGroupSwitch "/>
                                            </label>
                                        </li>                                        
                                        <li>
                                            <label class="label-checkbox-menu-default" title="Operating System">
                                                <span>Operating System</span>
                                                <input type="radio" id="radio-dimension-os" name="switch-dimension-os" value="os" data-bind="event: {change: onDimensionGroupSwitch.bind($data, 'os')}, checked: dimensionGroupSwitch"/>
                                            </label>
                                        </li>
                                        <li>
                                            <label class="label-checkbox-menu-default" title="Browser">
                                                <span>Browser</span>
                                                <input type="radio" id="radio-dimension-browser" name="switch-dimension-browser" value="browser" data-bind="event: {change: onDimensionGroupSwitch.bind($data, 'browser')}, checked: dimensionGroupSwitch"/>
                                            </label>
                                        </li>
                                        <li>
                                            <label class="label-checkbox-menu-default" title="Ad Block">
                                                <span>Ad Block</span>
                                                <input type="radio" id="radio-dimension-adBlockerStatus" name="switch-dimension-adBlockerStatus" value="adBlockerStatus" data-bind="event: {change: onDimensionGroupSwitch.bind($data, 'adBlockerStatus')}, checked: dimensionGroupSwitch"/>
                                            </label>
                                        </li>                                        
                                        <li>
                                            <label class="label-checkbox-menu-default" title="Geo">
                                                <span>Geo</span>
                                                <input type="radio" id="radio-dimension-geo" name="switch-dimension-geo" value="geo" data-bind="event: {change: onDimensionGroupSwitch.bind($data, 'geo')}, checked: dimensionGroupSwitch"/>
                                            </label>
                                        </li>
                                        <li>
                                            <label class="label-checkbox-menu-default" title="AMP">
                                                <span>AMP</span>
                                                <input type="radio" id="radio-dimension-ampStatus" name="switch-dimension-ampStatus" value="ampStatus" data-bind="event: {change: onDimensionGroupSwitch.bind($data, 'ampStatus')}, checked: dimensionGroupSwitch "/>
                                            </label>
                                        </li>
                                        <li>
                                            <label class="label-checkbox-menu-default" title="Referrer">
                                                <span>Referrer</span>
                                                <input type="radio" id="radio-dimension-referrer" name="switch-dimension-referrer" value="referrer" data-bind="event: {change: onDimensionGroupSwitch.bind($data, 'referrer')}, checked: dimensionGroupSwitch"/>
                                            </label>
                                        </li>                                        
                                        <li>
                                            <label class="label-checkbox-menu-default" title="Hostname">
                                                <span>Hostname</span>
                                                <input type="radio" id="radio-dimension-hostname" name="switch-dimension-hostname" value="hostname" data-bind="event: {change: onDimensionGroupSwitch.bind($data, 'hostname')}, checked: dimensionGroupSwitch"/>
                                            </label>
                                        </li>
                                        <li>
                                            <label class="label-checkbox-menu-default" title="Login Status">
                                                <span>Login Status</span>
                                                <input type="radio" id="radio-dimension-loginStatus" name="switch-dimension-loginStatus" value="loginStatus" data-bind="event: {change: onDimensionGroupSwitch.bind($data, 'loginStatus')}, checked: dimensionGroupSwitch"/>
                                            </label>
                                        </li>
                                        <li>
                                            <label class="label-checkbox-menu-default" title="Plan">
                                                <span>Plan</span>
                                                <input type="radio" id="radio-dimension-plan" name="switch-dimension-plan" value="plan" data-bind="event: {change: onDimensionGroupSwitch.bind($data, 'plan')}, checked: dimensionGroupSwitch"/>
                                            </label>
                                        </li>
                                        <li>
                                            <label class="label-checkbox-menu-default" title="Identity Source">
                                                <span>Identity Source</span>
                                                <input type="radio" id="radio-dimension-identity-source" name="switch-dimension-identity-source" value="identitySource" data-bind="event: {change: onDimensionGroupSwitch.bind($data, 'identitySource')}, checked: dimensionGroupSwitch"/>
                                            </label>
                                        </li>
                                        <li>
                                            <label class="label-checkbox-menu-default" title="Robot Name">
                                                <span>Robot Name</span>
                                                <input type="radio" id="radio-dimension-robotName" name="switch-dimension-robotName" value="robotName" data-bind="event: {change: onDimensionGroupSwitch.bind($data, 'robotName')}, checked: dimensionGroupSwitch"/>
                                            </label>
                                        </li>
                                        <li>
                                            <label class="label-checkbox-menu-default" title="Robot Category">
                                                <span>Robot Category</span>
                                                <input type="radio" id="radio-dimension-robotCategory" name="switch-dimension-robotCategory" value="robotCategory" data-bind="event: {change: onDimensionGroupSwitch.bind($data, 'robotCategory')}, checked: dimensionGroupSwitch"/>
                                            </label>
                                        </li>
                                    </ul>
                                </div>
                                <div>
                                    <span class="label-default icon i-dimensions">UTMs</span>
                                    <ul class="sidebar-default-list">
                                        <li>
                                            <label class="label-checkbox-menu-default" title="UTM Campaign">
                                                <span>UTM Campaign</span>
                                                <input type="radio" id="radio-dimension-utmCampaign" name="switch-dimension-utmCampaign" value="utmCampaign" data-bind="event: {change: onDimensionGroupSwitch.bind($data, 'utmCampaign')}, checked: dimensionGroupSwitch"/>
                                            </label>
                                        </li>
                                        <li>
                                            <label class="label-checkbox-menu-default" title="UTM Medium">
                                                <span>UTM Medium</span>
                                                <input type="radio" id="radio-dimension-utmMedium" name="switch-dimension-utmMedium" value="utmMedium" data-bind="event: {change: onDimensionGroupSwitch.bind($data, 'utmMedium')}, checked: dimensionGroupSwitch"/>
                                            </label>
                                        </li>
                                        <li>
                                            <label class="label-checkbox-menu-default" title="UTM Source">
                                                <span>UTM Source</span>
                                                <input type="radio" id="radio-dimension-utmSource" name="switch-dimension-utmSource" value="utmSource" data-bind="event: {change: onDimensionGroupSwitch.bind($data, 'utmSource')}, checked: dimensionGroupSwitch"/>
                                            </label>
                                        </li>
                                    </ul>
                                </div>
                                <!-- ko if: customDimensionsNames().length > 0 -->
                                    <div>
                                        <span class="label-default icon i-dimensions">Custom Dimensions</span>
                                        <ul class="sidebar-default-list">
                                            <!-- ko foreach: customDimensionsNames -->
                                                <li>
                                                    <label class="label-checkbox-menu-default" title="Default" data-bind="attr: {title: name}">
                                                        <span data-bind="text: name"></span>
                                                        <input type="radio" data-bind="attr: { id: 'radio-dimension-' + name, name: 'switch-dimension-' + name, value: name }, event: { change: $parent.onDimensionGroupSwitch.bind($parent, name) }, checked: $parent.dimensionGroupSwitch"/>                            </label>
                                                </li>
                                            <!-- /ko -->
                                        </ul>
                                    </div>
                                <!-- /ko -->
                            </div>
                        </nav>
                    </div>

                    <nav class="sidebar-default sidebar-default-right" data-bind="css:{'is-open': isFiltersOpen()}">
                        <div class="sidebar-default-header">
                            <span class="label-default sidebar-default-header icon i-filters">Filters</span>
                            <button type="button" class="btn-close-default icon i-close" data-bind="event: { click: toggleOpenFilters }"><span></span></button>
                        </div>

                        <div class="sidebar-default-body">

                            <div>

                                <!-- ko foreach: dynamicFiltersGrouped -->

                                    <span class="form-label" data-bind="text: categoryName"></span>

                                    <div class="dynamic-filters w-add-filters-list">
                                    <!-- ko foreach: Object.values(names) -->

                                        <div class="filter-group">

                                            <div class="checkbox-group">
                                                <label class="icon i-dropdown-simple">
                                                    <input class="expected" type="checkbox" />
                                                </label>
                                            </div>

                                            <!-- ko foreach: filters -->

                                                <!-- ko if: type === 'multiSelect' -->
                                                    <div data-bind="template: {name: 'multiSelector-template', data: filter.getTemplateViewModel()}" class="has-multi"></div>
                                                <!-- /ko -->

                                                <!-- ko if: type === 'autoCompleteMultiSelect' -->
                                                    <div data-bind="template: {name: 'filterMultipleAutoComplete-template', data: filter.getTemplateViewModel()}"></div>
                                                <!-- /ko -->

                                                <!-- ko if: type === 'searchField' -->
                                                    <div data-bind="template: {name: 'filterSimple-template', data: filter.getTemplateViewModel()}"></div>
                                                <!-- /ko -->

                                            <!-- /ko -->
                                        </div> <!-- End filter-group -->
                                    <!-- /ko -->
                                    </div>
                                <!-- /ko -->

                            </div>
                        </div>
                    </nav>

                    <div class="w-right flex-all block-default">
                        <div class="w-justify full-width">
                            <div class="w-left">
                                <div class="with-click">
                                    <div class="w-brand-filter">
                                        ${this.brandFilter.getHtmlBuild()}
                                    </div>
                                </div>

                                <div class="w-range-compare" data-bind="css: {'is-comp-activated': showComparisonDateRange()}">
                                    ${this.dateRangeFilter.getHtmlBuild()}
                                    <div class="w-compare">
                                        ${this.compRangeFilter.getHtmlBuild()}
                                    </div>
                                </div>

                                <div class="with-click" style="position:relative;display:flex">
                                    ${this.compareFilter.getHtmlBuild()}
                                    <div style="margin-left:-0.5rem">
                                        <button  data-bind="visible: isVisibleCompareClear(), event: { click: onClickClearCompareClear }" class="btn-filter clear icon icon i-x-after"><span class="hide-text">Clear</span></button>
                                    </div>
                                </div>

                                <div class="separator"></div>

                                <button class="icon i-filters no-after filterToggle-btn" data-bind="event: {click: toggleOpenFilters}">Filters</button>

                            </div>

                            <div class="w-right ">
                                <div class="w-filter-preset hide-mobile" data-bind="visible: false, event: { mouseover: onMouseOverPreset, mouseout: onMouseOutPreset}">
                                    ` + this.presetFilter.getHtmlBuild() + `
                                </div>

                            </div>

                        </div>
                    </div>

                </div>

                <div class="w-justify">
                    <div class="w-left">
                        <div class="w-filters-selected">
                            <div id="filters-selected" class="filters-selected">
                                <div id="selected-geos"></div>
                                <div id="selected-devices"></div>
                                <div id="selected-os"></div>
                                <div id="selected-browsers"></div>
                                <div id="selected-login-status"></div>
                                <div id="selected-referrers"></div>
                                <div id="selected-plans"></div>
                                <div id="selected-ad-blocks"></div>
                                <!-- ko foreach: dynamicFilters -->
                                    <div data-bind="attr: { id: 'selected-' + name }"></div>
                                <!-- /ko -->
                            </div>
                        </div>
                    </div>
                </div>

                <!-- ko if: sampledDatesData() && sampledDatesData().length > 0 -->
                    <div class="w-block-message plus theme-light">
                        <div class="block-message-content">
                            <p><strong>Note:</strong> The selected date range includes periods where data was sampled.</p>
                        </div>
                    </div>
                <!-- /ko -->

                <div class="block-default block-filters header w-justify" style="padding-left: 1.5rem;display: flex;align-items: flex-start">
                    <div class="w-left">
                        ${this.graphMetricFilter.getHtmlBuild()}
                    </div>

                    <div class="w-right" data-bind= "visible: timelineAnnotationsData().length">
                        <span class="label-annotation"></span>
                        <div class="w-tooltips-adv auto-height short pos-top-left">
                            ${this.annotationTooltip.getHtmlBuild()}
                        </div>
                    </div>
                </div>

                <section class="w-graph block-default rogue no-padding radius-top">
                    <div class="graph" id="indicatorsByDate-results"  data-bind="css: { loading: false }">
                        ${this.viewsChart.getHtmlBuild()}
                    </div>
                </section>

                <div id="dimensionsByDate-results" class="wrapper-list-results">

                    <div class="w-justify list-results-header">

                        <div class="w-left">

                            <!-- ko if: isPaginationEnabled -->
                                <div>` + this.pagination.getHtmlBuild() + `</div>
                            <!-- /ko -->

                            <div class="block-filters no-margin rogue">
                                ${this.tableMetricFilter.getHtmlBuild()}
                            </div>
                            <div class="top-pages-v2-metric-toggles" aria-label="Optional engagement columns">
                                <button class="top-pages-v2-metric-toggle" type="button" data-bind="event: { click: toggleAverageViewDuration }, css: { 'is-active': showAverageViewDuration }, attr: { 'aria-pressed': showAverageViewDuration, title: showAverageViewDuration() ? 'Hide AVD column' : 'Show AVD column' }">
                                    <span class="icon" data-bind="css: { 'i-simplify': showAverageViewDuration(), 'i-expand': !showAverageViewDuration() }" aria-hidden="true"></span>
                                    <span>AVD</span>
                                </button>
                                <button class="top-pages-v2-metric-toggle" type="button" data-bind="event: { click: toggleEngagementBreakdown }, css: { 'is-active': showEngagementBreakdown }, attr: { 'aria-pressed': showEngagementBreakdown, title: showEngagementBreakdown() ? 'Hide 30s, 60s and 90s columns' : 'Show 30s, 60s and 90s columns' }">
                                    <span class="icon" data-bind="css: { 'i-simplify': showEngagementBreakdown(), 'i-expand': !showEngagementBreakdown() }" aria-hidden="true"></span>
                                    <span>30s / 60s / 90s</span>
                                </button>
                            </div>
                        </div>

                        <!-- ko if: isResultsInfoEnabled -->
                            <div class="w-center">
                                ` + this.resultsInfo.getHtmlBuild() + `
                            </div>
                        <!-- /ko -->

                        <div class="w-right">
                            <button class="button-default icon i-expand" type="button" data-bind= "visible: hasActiveComparison(), css: (comparisonSimplifyToggle() ? 'i-simplify' : 'i-expand'), text: (comparisonSimplifyToggle() ? 'Simplify' : 'Expand'), event: { click: onComparisonSimplifyToggle}"></button>
                            <button class="button-default icon i-export" type="button" data-bind="event: {click: onExportData}">Export</button>
                        </div>
                    </div>

                    <div class="gradient-overflow">
                        <div class="w-list-results">
                            <table class="list-results audience-overview" style="white-space: nowrap;" data-bind="css: { 'is-engagement-breakdown-visible': showEngagementBreakdown, 'is-average-view-duration-visible': showAverageViewDuration, 'has-active-comparison': hasActiveComparison, 'is-comparison-expanded': comparisonSimplifyToggle }">

                                <!-- ko if: viewMode() == 'traffic' -->
                                    <thead>
                                        <tr class="table-metric-parent-headers audience-overview-groups">
                                            <th></th>
                                            <th class="table-metric-parent-header table-metric-parent-header--traffic" scope="colgroup" data-bind="attr: { colspan: hasActiveComparison() ? 6 : 3 }">Traffic</th>
                                            <th class="table-metric-parent-header table-metric-parent-header--engagement" scope="colgroup" data-bind="attr: { colspan: (6 + (showAverageViewDuration() ? 1 : 0) + (showEngagementBreakdown() ? 6 : 0)) * (hasActiveComparison() && comparisonSimplifyToggle() ? 2 : 1) }">
                                                <div class="table-metric-parent-header-content"><span>Engagement</span></div>
                                            </th>
                                            <th class="table-metric-parent-header table-metric-parent-header--us" scope="colgroup" data-bind="attr: { colspan: hasActiveComparison() && comparisonSimplifyToggle() ? 8 : 4 }">Marketability</th>
                                        </tr>
                                        <tr>

                                            <th>
                                                <span data-bind="text: getDimensionNiceName()"></span>
                                            </th>

                                            <th data-bind="visible: hasActiveComparison()">
                                                <span style="color: #D8366D !important" data-bind="text: 'Sessions Comp'"></span>
                                            </th>

                                            <th>
                                                <span>Sessions</span>
                                            </th>

                                            <th data-bind="visible: hasActiveComparison()">
                                                <span style="color: #D8366D !important" data-bind="text: 'Visits Comp'"></span>
                                            </th>

                                            <th>
                                                <span>Visits</span>
                                            </th>

                                            <th data-bind="visible: hasActiveComparison()">
                                                <span style="color: #D8366D !important" data-bind="text: 'Views Comp'"></span>
                                            </th>

                                            <th>
                                                <span>Views</span>
                                            </th>

                                            <!-- ko foreach: engagementMetrics -->
                                                <th data-bind="visible: (!$data.isExpandable || $parent.showEngagementBreakdown()) && $parent.hasActiveComparison() && $parent.comparisonSimplifyToggle(), css: { 'top-pages-v2-expanded-column': $data.isExpandable && $parent.showEngagementBreakdown(), 'top-pages-v2-expanded-column--end': field === 'engaged90SecondsVisitPercentage' || field === 'engaged90SecondsViewPercentage' }">
                                                    <span style="color: #D8366D !important" data-bind="text: name + ' Comp'"></span>
                                                </th>

                                                <th data-bind="visible: !$data.isExpandable || $parent.showEngagementBreakdown(), css: { 'top-pages-v2-expanded-column': $data.isExpandable && $parent.showEngagementBreakdown(), 'top-pages-v2-expanded-column--end': field === 'engaged90SecondsVisitPercentage' || field === 'engaged90SecondsViewPercentage' }">
                                                    <span data-bind="css: { 'duration-label': $data.isExpandable || field === 'timeOnPage' }, html: $data.isExpandable ? name.replace('s+', '<small class=&quot;duration-unit&quot;>s</small>+') : name"></span>
                                                </th>
                                            <!-- /ko -->

                                            <th data-bind="visible: showAverageViewDuration() && hasActiveComparison() && comparisonSimplifyToggle(), css: { 'top-pages-v2-average-duration-column': showAverageViewDuration() }">
                                                <span style="color: #D8366D !important" data-bind="text: 'AVD (mm:ss) Comp'"></span>
                                            </th>

                                            <th data-bind="visible: showAverageViewDuration(), css: { 'top-pages-v2-average-duration-column': showAverageViewDuration() }">
                                                <span>AVD (mm:ss)</span>
                                            </th>

                                            <th data-bind="visible:  hasActiveComparison() && comparisonSimplifyToggle()">
                                                <span style="color: #D8366D !important" data-bind="text: 'Scroll Depth % Comp'"></span>
                                            </th>

                                            <th>
                                                <span>Scroll Depth %</span>
                                            </th>

                                            <th data-bind="visible:  hasActiveComparison() && comparisonSimplifyToggle()">
                                                <span style="color: #D8366D !important" data-bind="text: 'Avg Speed (Mbps) Comp'"></span>
                                            </th>

                                            <th>
                                                <span>Avg Speed (Mbps)</span>
                                            </th>

                                            <th data-bind="visible:  hasActiveComparison() && comparisonSimplifyToggle()">
                                                <span style="color: #D8366D !important" data-bind="text: 'Logged-In Sessions Comp'"></span>
                                            </th>

                                            <th>
                                                <span>Logged-In Sessions</span>
                                            </th>

                                            <th data-bind="visible:  hasActiveComparison() && comparisonSimplifyToggle()">
                                                <span style="color: #D8366D !important" data-bind="text: 'Logged-In Visits Comp'"></span>
                                            </th>

                                            <th>
                                                <span>Logged-In Visits</span>
                                            </th>

                                            <th data-bind="visible:  hasActiveComparison() && comparisonSimplifyToggle()">
                                                <span style="color: #D8366D !important" data-bind="text: 'Logged-In Views Comp'"></span>
                                            </th>

                                            <th>
                                                <span>Logged-In Views</span>
                                            </th>

                                        </tr>

                                    </thead>
                                    <tbody>

                                    <!-- ko if : dimensionsTotals.length > 0 -->
                                        <tr class="total-row">
                                            <td>
                                                <span data-bind="text: 'Total'"></span>
                                            </td>

                                            <!-- ko with: dimensionsTotals -->
                                                <td data-bind="visible: $parent.hasActiveComparison()">
                                                    <span style="color: #D8366D !important" data-bind="text: isNaN($data.sessionCount_comp) || $data.sessionCount_comp === null ? $data.sessionCount_comp : Number($data.sessionCount_comp).toLocaleString('en-EG', {minimumFractionDigits: 0, maximumFractionDigits: 0})"></span>
                                                    <span style="color: #D8366D !important" class="row-percentage" data-bind="text: isNaN($data.sessionCount_delta) || $data.sessionCount_delta === null ? $data.sessionCount_delta : ' (' + Number($data.sessionCount_delta).toLocaleString('en-EG', {minimumFractionDigits: 1, maximumFractionDigits: 1}) + '%)'"></span>
                                                </td>

                                                <td>
                                                    <span data-bind="text: Number($data.sessionCount).toLocaleString('en-EG', {minimumFractionDigits: 0, maximumFractionDigits: 0})"></span>
                                                </td>

                                                <td data-bind="visible: $parent.hasActiveComparison()">
                                                    <span style="color: #D8366D !important" data-bind="text: isNaN($data.visitCount_comp) || $data.visitCount_comp === null ? $data.visitCount_comp : Number($data.visitCount_comp).toLocaleString('en-EG', {minimumFractionDigits: 0, maximumFractionDigits: 0})"></span>
                                                    <span style="color: #D8366D !important" class="row-percentage" data-bind="text: isNaN($data.visitCount_delta) || $data.visitCount_delta === null ? $data.visitCount_delta : ' (' + Number($data.visitCount_delta).toLocaleString('en-EG', {minimumFractionDigits: 1, maximumFractionDigits: 1}) + '%)'"></span>
                                                </td>

                                                <td>
                                                    <span data-bind="text: Number($data.visitCount).toLocaleString('en-EG', {minimumFractionDigits: 0, maximumFractionDigits: 0})"></span>
                                                </td>

                                                <td data-bind="visible: $parent.hasActiveComparison()">
                                                    <span style="color: #D8366D !important" data-bind="text: isNaN($data.viewCount_comp) || $data.viewCount_comp === null ? $data.viewCount_comp : Number($data.viewCount_comp).toLocaleString('en-EG', {minimumFractionDigits: 0, maximumFractionDigits: 0})"></span>
                                                    <span style="color: #D8366D !important" class="row-percentage" data-bind="text: isNaN($data.viewCount_delta) || $data.viewCount_delta === null ? $data.viewCount_delta : ' (' + Number($data.viewCount_delta).toLocaleString('en-EG', {minimumFractionDigits: 1, maximumFractionDigits: 1}) + '%)'"></span>
                                                </td>

                                                <td>
                                                    <span data-bind="text: Number($data.viewCount).toLocaleString('en-EG', {minimumFractionDigits: 0, maximumFractionDigits: 0})"></span>
                                                </td>

                                                <!-- ko foreach: $parent.engagementMetrics -->
                                                    <td data-bind="visible: (!$data.isExpandable || $parents[1].showEngagementBreakdown()) && $parents[1].hasActiveComparison() && $parents[1].comparisonSimplifyToggle(), css: { 'top-pages-v2-expanded-column': $data.isExpandable && $parents[1].showEngagementBreakdown(), 'top-pages-v2-expanded-column--end': field === 'engaged90SecondsVisitPercentage' || field === 'engaged90SecondsViewPercentage' }">
                                                        <span style="color: #D8366D !important" data-bind="text: $parents[1].formatEngagementMetric($parent[field + '_comp'], format)"></span>
                                                        <!-- ko if: countField -->
                                                            <small style="color: #D8366D !important" data-bind="text: ' (' + $parents[1].formatEngagementMetric($parent[countField + '_comp'], 'count') + ')'"></small>
                                                        <!-- /ko -->
                                                        <span style="color: #D8366D !important" class="row-percentage" data-bind="text: $parents[1].formatMetricDelta($parent[field + '_delta'])"></span>
                                                    </td>

                                                    <td data-bind="visible: !$data.isExpandable || $parents[1].showEngagementBreakdown(), css: { 'top-pages-v2-expanded-column': $data.isExpandable && $parents[1].showEngagementBreakdown(), 'top-pages-v2-expanded-column--end': field === 'engaged90SecondsVisitPercentage' || field === 'engaged90SecondsViewPercentage' }">
                                                        <span data-bind="text: $parents[1].formatEngagementMetric($parent[field], format)"></span>
                                                        <!-- ko if: countField -->
                                                            <small data-bind="text: ' (' + $parents[1].formatEngagementMetric($parent[countField], 'count') + ')'"></small>
                                                        <!-- /ko -->
                                                    </td>
                                                <!-- /ko -->

                                                <td data-bind="visible: $parent.showAverageViewDuration() && $parent.hasActiveComparison() && $parent.comparisonSimplifyToggle(), css: { 'top-pages-v2-average-duration-column': $parent.showAverageViewDuration() }">
                                                    <span style="color: #D8366D !important" data-bind="text: $parent.formatMinuteSeconds($data.avgViewEngagedSeconds_comp)"></span>
                                                    <span style="color: #D8366D !important" class="row-percentage" data-bind="text: isNaN($data.avgViewEngagedSeconds_delta) || $data.avgViewEngagedSeconds_delta === null ? $data.avgViewEngagedSeconds_delta : ' (' + Number($data.avgViewEngagedSeconds_delta).toLocaleString('en-EG', {minimumFractionDigits: 1, maximumFractionDigits: 1}) + '%)'"></span>
                                                </td>

                                                <td data-bind="visible: $parent.showAverageViewDuration(), css: { 'top-pages-v2-average-duration-column': $parent.showAverageViewDuration() }">
                                                    <span data-bind="text: $parent.formatMinuteSeconds($data.avgViewEngagedSeconds)"></span>
                                                </td>

                                                <td data-bind="visible: $parent.hasActiveComparison() && $parent.comparisonSimplifyToggle()">
                                                    <span style="color: #D8366D !important" data-bind="text: isNaN($data.avgViewEngagedDepthPercentage_comp) || $data.avgViewEngagedDepthPercentage_comp === null ? $data.avgViewEngagedDepthPercentage_comp : Number($data.avgViewEngagedDepthPercentage_comp).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2}) + '%'"></span>
                                                    <span style="color: #D8366D !important" class="row-percentage" data-bind="text: isNaN($data.avgViewEngagedDepthPercentage_delta) || $data.avgViewEngagedDepthPercentage_delta === null ? $data.avgViewEngagedDepthPercentage_delta : ' (' + Number($data.avgViewEngagedDepthPercentage_delta).toLocaleString('en-EG', {minimumFractionDigits: 1, maximumFractionDigits: 1}) + '%)'"></span>
                                                </td>

                                                <td>
                                                    <span data-bind="text: Number($data.avgViewEngagedDepthPercentage).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2}) + '%'"></span>
                                                </td>

                                                <td data-bind="visible: $parent.hasActiveComparison() && $parent.comparisonSimplifyToggle()">
                                                    <span style="color: #D8366D !important" data-bind="text: isNaN($data.avgConnectionSpeed_comp) || $data.avgConnectionSpeed_comp === null ? $data.avgConnectionSpeed_comp : Number($data.avgConnectionSpeed_comp).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2})"></span>
                                                    <span style="color: #D8366D !important" class="row-percentage" data-bind="text: isNaN($data.avgConnectionSpeed_delta) || $data.avgConnectionSpeed_delta === null ? $data.avgConnectionSpeed_delta : ' (' + Number($data.avgConnectionSpeed_delta).toLocaleString('en-EG', {minimumFractionDigits: 1, maximumFractionDigits: 1}) + '%)'"></span>
                                                </td>

                                                <td>
                                                    <span data-bind="text: Number($data.avgConnectionSpeed).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2})"></span>
                                                </td>

                                                <td data-bind="visible: $parent.hasActiveComparison() && $parent.comparisonSimplifyToggle()">
                                                    <span style="color: #D8366D !important" data-bind="text: isNaN($data.avgLoggedInSessionPercentage_comp) || $data.avgLoggedInSessionPercentage_comp === null ? $data.avgLoggedInSessionPercentage_comp : Number($data.avgLoggedInSessionPercentage_comp).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2}) + '%'"></span>
                                                    <span style="color: #D8366D !important" class="row-percentage" data-bind="text: isNaN($data.avgLoggedInSessionPercentage_delta) || $data.avgLoggedInSessionPercentage_delta === null ? $data.avgLoggedInSessionPercentage_delta : ' (' + Number($data.avgLoggedInSessionPercentage_delta).toLocaleString('en-EG', {minimumFractionDigits: 1, maximumFractionDigits: 1}) + '%)'"></span>
                                                </td>

                                                <td>
                                                    <span data-bind="text: Number($data.avgLoggedInSessionPercentage).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2}) + '%'"></span>
                                                </td>

                                                <td data-bind="visible: $parent.hasActiveComparison() && $parent.comparisonSimplifyToggle()">
                                                    <span style="color: #D8366D !important" data-bind="text: isNaN($data.avgLoggedInVisitPercentage_comp) || $data.avgLoggedInVisitPercentage_comp === null ? $data.avgLoggedInVisitPercentage_comp : Number($data.avgLoggedInVisitPercentage_comp).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2}) + '%'"></span>
                                                    <span style="color: #D8366D !important" class="row-percentage" data-bind="text: isNaN($data.avgLoggedInVisitPercentage_delta) || $data.avgLoggedInVisitPercentage_delta === null ? $data.avgLoggedInVisitPercentage_delta : ' (' + Number($data.avgLoggedInVisitPercentage_delta).toLocaleString('en-EG', {minimumFractionDigits: 1, maximumFractionDigits: 1}) + '%)'"></span>
                                                </td>

                                                <td>
                                                    <span data-bind="text: Number($data.avgLoggedInVisitPercentage).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2}) + '%'"></span>
                                                </td>

                                                <td data-bind="visible: $parent.hasActiveComparison() && $parent.comparisonSimplifyToggle()">
                                                    <span style="color: #D8366D !important" data-bind="text: isNaN($data.avgLoggedInViewPercentage_comp) || $data.avgLoggedInViewPercentage_comp === null ? $data.avgLoggedInViewPercentage_comp : Number($data.avgLoggedInViewPercentage_comp).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2}) + '%'"></span>
                                                    <span style="color: #D8366D !important" class="row-percentage" data-bind="text: isNaN($data.avgLoggedInViewPercentage_delta) || $data.avgLoggedInViewPercentage_delta === null ? $data.avgLoggedInViewPercentage_delta : ' (' + Number($data.avgLoggedInViewPercentage_delta).toLocaleString('en-EG', {minimumFractionDigits: 1, maximumFractionDigits: 1}) + '%)'"></span>
                                                </td>

                                                <td>
                                                    <span data-bind="text: Number($data.avgLoggedInViewPercentage).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2}) + '%'"></span>
                                                </td>

                                            <!-- /ko -->
                                        </tr>
                                        <!-- /ko -->

                                        <!-- ko foreach: dimensionsData -->
                                            <tr data-bind="event: { click: $parent.onClickRowClick.bind($data, $index(), $data)}, style: { 'background-color': $parent.selectedRows().indexOf($index()) !== -1 ? '#dbdbed' : '' }">
                                                <td>
                                                    <span class="align-left no-wrap" data-bind="text: $parent.formatDimensionValue(dimension, $parent.dimensionGroupSwitch())"></span>
                                                </td>

                                                <td data-bind="visible: $parent.hasActiveComparison()">
                                                    <span style="color: #D8366D !important" data-bind="text: isNaN(sessionCount_comp) || sessionCount_comp === null ? sessionCount_comp : Number(sessionCount_comp).toLocaleString('en-EG', {minimumFractionDigits: 0, maximumFractionDigits: 0})"></span>
                                                    <span style="color: #D8366D !important" class="row-percentage" data-bind="text: isNaN(sessionCount_delta) || sessionCount_delta === null ? sessionCount_delta : ' (' + Number(sessionCount_delta).toLocaleString('en-EG', {minimumFractionDigits: 1, maximumFractionDigits: 1}) + '%)'"></span>
                                                </td>

                                                <td>
                                                    <span data-bind="text: isNaN(sessionCount) || sessionCount === null ? sessionCount : Number(sessionCount).toLocaleString('en-EG', {minimumFractionDigits: 0, maximumFractionDigits: 0})"></span>
                                                    <span class="row-percentage" data-bind="text: isNaN(sessionCount) || sessionCount === null ? sessionCount : ' (' + Number($parent.dimensionsTotals().sessionCount === 0 ? 0 : sessionCount/$parent.dimensionsTotals().sessionCount*100).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2}) + '%)'"></span>
                                                </td>

                                                <td data-bind="visible: $parent.hasActiveComparison()">
                                                    <span style="color: #D8366D !important" data-bind="text: isNaN($data.visitCount_comp) || $data.visitCount_comp === null ? $data.visitCount_comp : Number($data.visitCount_comp).toLocaleString('en-EG', {minimumFractionDigits: 0, maximumFractionDigits: 0})"></span>
                                                    <span style="color: #D8366D !important" class="row-percentage" data-bind="text: isNaN(visitCount_delta) || visitCount_delta === null ? $data.visitCount_delta : ' (' + Number($data.visitCount_delta).toLocaleString('en-EG', {minimumFractionDigits: 1, maximumFractionDigits: 1}) + '%)'"></span>
                                                </td>

                                                <td>
                                                    <span data-bind="text: isNaN(visitCount) || visitCount === null ? $data.visitCount : Number($data.visitCount).toLocaleString('en-EG', {minimumFractionDigits: 0, maximumFractionDigits: 0})"></span>
                                                    <span class="row-percentage" data-bind="text: isNaN(visitCount) || visitCount === null ? $data.visitCount : ' (' + Number($parent.dimensionsTotals().visitCount === 0 ? 0 : $data.visitCount/$parent.dimensionsTotals().visitCount*100).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2}) + '%)'"></span>
                                                </td>

                                                <td data-bind="visible: $parent.hasActiveComparison()">
                                                    <span style="color: #D8366D !important" data-bind="text: isNaN(viewCount_comp) || viewCount_comp === null ? $data.viewCount_comp : Number($data.viewCount_comp).toLocaleString('en-EG', {minimumFractionDigits: 0, maximumFractionDigits: 0})"></span>
                                                    <span style="color: #D8366D !important" class="row-percentage" data-bind="text: isNaN(viewCount_delta) || viewCount_delta === null ? $data.viewCount_delta : ' (' + Number($data.viewCount_delta).toLocaleString('en-EG', {minimumFractionDigits: 1, maximumFractionDigits: 1}) + '%)'"></span>
                                                </td>

                                                <td>
                                                    <span data-bind="text: isNaN(viewCount) || viewCount === null ? $data.viewCount : Number($data.viewCount).toLocaleString('en-EG', {minimumFractionDigits: 0, maximumFractionDigits: 0})"></span>
                                                    <span class="row-percentage" data-bind="text: isNaN(viewCount) || viewCount === null ? $data.viewCount : ' (' + Number($parent.dimensionsTotals().viewCount === 0 ? 0 : $data.viewCount/$parent.dimensionsTotals().viewCount*100).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2}) + '%)'"></span>
                                                </td>

                                                <!-- ko foreach: $parent.engagementMetrics -->
                                                    <td data-bind="visible: (!$data.isExpandable || $parents[1].showEngagementBreakdown()) && $parents[1].hasActiveComparison() && $parents[1].comparisonSimplifyToggle(), css: { 'top-pages-v2-expanded-column': $data.isExpandable && $parents[1].showEngagementBreakdown(), 'top-pages-v2-expanded-column--end': field === 'engaged90SecondsVisitPercentage' || field === 'engaged90SecondsViewPercentage' }">
                                                        <span style="color: #D8366D !important" data-bind="text: $parents[1].formatEngagementMetric($parent[field + '_comp'], format)"></span>
                                                        <!-- ko if: countField -->
                                                            <small style="color: #D8366D !important" data-bind="text: ' (' + $parents[1].formatEngagementMetric($parent[countField + '_comp'], 'count') + ')'"></small>
                                                        <!-- /ko -->
                                                        <span style="color: #D8366D !important" class="row-percentage" data-bind="text: $parents[1].formatMetricDelta($parent[field + '_delta'])"></span>
                                                    </td>

                                                    <td data-bind="visible: !$data.isExpandable || $parents[1].showEngagementBreakdown(), css: { 'top-pages-v2-expanded-column': $data.isExpandable && $parents[1].showEngagementBreakdown(), 'top-pages-v2-expanded-column--end': field === 'engaged90SecondsVisitPercentage' || field === 'engaged90SecondsViewPercentage' }">
                                                        <span data-bind="text: $parents[1].formatEngagementMetric($parent[field], format)"></span>
                                                        <!-- ko if: countField -->
                                                            <small data-bind="text: ' (' + $parents[1].formatEngagementMetric($parent[countField], 'count') + ')'"></small>
                                                        <!-- /ko -->
                                                    </td>
                                                <!-- /ko -->

                                                <td data-bind="visible: $parent.showAverageViewDuration() && $parent.hasActiveComparison() && $parent.comparisonSimplifyToggle(), css: { 'top-pages-v2-average-duration-column': $parent.showAverageViewDuration() }">
                                                    <span style="color: #D8366D !important" data-bind="text: $parent.formatMinuteSeconds($data.avgViewEngagedSeconds_comp)"></span>
                                                    <span style="color: #D8366D !important" class="row-percentage" data-bind="text: isNaN($data.avgViewEngagedSeconds_delta) || $data.avgViewEngagedSeconds_delta === null ? $data.avgViewEngagedSeconds_delta : ' (' + Number($data.avgViewEngagedSeconds_delta).toLocaleString('en-EG', {minimumFractionDigits: 1, maximumFractionDigits: 1}) + '%)'"></span>
                                                </td>


                                                <td data-bind="visible: $parent.showAverageViewDuration(), css: { 'top-pages-v2-average-duration-column': $parent.showAverageViewDuration() }">
                                                    <span data-bind="text: $parent.formatMinuteSeconds(avgViewEngagedSeconds)"></span>
                                                </td>

                                                <td data-bind="visible: $parent.hasActiveComparison() && $parent.comparisonSimplifyToggle()">
                                                    <span style="color: #D8366D !important" data-bind="text: isNaN($data.avgViewEngagedDepthPercentage_comp) || $data.avgViewEngagedDepthPercentage_comp === null ? $data.avgViewEngagedDepthPercentage_comp : Number($data.avgViewEngagedDepthPercentage_comp).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2}) + '%'"></span>
                                                    <span style="color: #D8366D !important" class="row-percentage" data-bind="text: isNaN($data.avgViewEngagedDepthPercentage_delta) || $data.avgViewEngagedDepthPercentage_delta === null ? $data.avgViewEngagedDepthPercentage_delta : ' (' + Number($data.avgViewEngagedDepthPercentage_delta).toLocaleString('en-EG', {minimumFractionDigits: 1, maximumFractionDigits: 1}) + '%)'"></span>
                                                </td>

                                                <td>
                                                    <span data-bind="text: isNaN($data.avgViewEngagedDepthPercentage) || $data.avgViewEngagedDepthPercentage === null ? $data.avgViewEngagedDepthPercentage : Number($data.avgViewEngagedDepthPercentage).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2}) + '%'"></span>
                                                </td>

                                                <td data-bind="visible: $parent.hasActiveComparison() && $parent.comparisonSimplifyToggle()">
                                                    <span style="color: #D8366D !important" data-bind="text: isNaN($data.avgConnectionSpeed_comp) || $data.avgConnectionSpeed_comp === null ? $data.avgConnectionSpeed_comp : Number($data.avgConnectionSpeed_comp).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2})"></span>
                                                    <span style="color: #D8366D !important" class="row-percentage" data-bind="text: isNaN(avgConnectionSpeed_delta) || avgConnectionSpeed_delta === null ? avgConnectionSpeed_delta : ' (' + Number(avgConnectionSpeed_delta).toLocaleString('en-EG', {minimumFractionDigits: 1, maximumFractionDigits: 1}) + '%)'"></span>
                                                </td>

                                                <td>
                                                    <span data-bind="text: isNaN(avgConnectionSpeed) || avgConnectionSpeed === null ? avgConnectionSpeed : Number(avgConnectionSpeed).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2})"></span>
                                                </td>

                                                <td data-bind="visible: $parent.hasActiveComparison() && $parent.comparisonSimplifyToggle()">
                                                    <span style="color: #D8366D !important" data-bind="text: isNaN(avgLoggedInSessionPercentage_comp) || avgLoggedInSessionPercentage_comp === null ? avgLoggedInSessionPercentage_comp : Number(avgLoggedInSessionPercentage_comp).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2}) + '%'"></span>
                                                    <span style="color: #D8366D !important" class="row-percentage" data-bind="text: isNaN(avgLoggedInSessionPercentage_delta) || avgLoggedInSessionPercentage_delta === null ? avgLoggedInSessionPercentage_delta : ' (' + Number(avgLoggedInSessionPercentage_delta).toLocaleString('en-EG', {minimumFractionDigits: 1, maximumFractionDigits: 1}) + '%)'"></span>
                                                </td>

                                                <td>
                                                    <span data-bind="text: isNaN(avgLoggedInSessionPercentage) || avgLoggedInSessionPercentage === null ? avgLoggedInSessionPercentage : Number(avgLoggedInSessionPercentage).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2}) + '%'"></span>
                                                </td>

                                                <td data-bind="visible: $parent.hasActiveComparison() && $parent.comparisonSimplifyToggle()">
                                                    <span style="color: #D8366D !important" data-bind="text: isNaN($data.avgLoggedInVisitPercentage_comp) || $data.avgLoggedInVisitPercentage_comp === null ? $data.avgLoggedInVisitPercentage_comp : Number($data.avgLoggedInVisitPercentage_comp).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2}) + '%'"></span>
                                                    <span style="color: #D8366D !important" class="row-percentage" data-bind="text: isNaN($data.avgLoggedInVisitPercentage_delta) || $data.avgLoggedInVisitPercentage_delta === null ? $data.avgLoggedInVisitPercentage_delta : ' (' + Number($data.avgLoggedInVisitPercentage_delta).toLocaleString('en-EG', {minimumFractionDigits: 1, maximumFractionDigits: 1}) + '%)'"></span>
                                                </td>

                                                <td>
                                                    <span data-bind="text: isNaN($data.avgLoggedInVisitPercentage) || $data.avgLoggedInVisitPercentage === null ? $data.avgLoggedInVisitPercentage : Number($data.avgLoggedInVisitPercentage).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2}) + '%'"></span>
                                                </td>

                                                <td data-bind="visible: $parent.hasActiveComparison() && $parent.comparisonSimplifyToggle()">
                                                    <span style="color: #D8366D !important" data-bind="text: isNaN($data.avgLoggedInViewPercentage_comp) || $data.avgLoggedInViewPercentage_comp === null ? $data.avgLoggedInViewPercentage_comp : Number($data.avgLoggedInViewPercentage_comp).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2}) + '%'"></span>
                                                    <span style="color: #D8366D !important" class="row-percentage" data-bind="text: isNaN($data.avgLoggedInViewPercentage_delta) || $data.avgLoggedInViewPercentage_delta === null ? $data.avgLoggedInViewPercentage_delta : ' (' + Number($data.avgLoggedInViewPercentage_delta).toLocaleString('en-EG', {minimumFractionDigits: 1, maximumFractionDigits: 1}) + '%)'"></span>
                                                </td>

                                                <td>
                                                    <span data-bind="text: isNaN($data.avgLoggedInViewPercentage) || $data.avgLoggedInViewPercentage === null ? $data.avgLoggedInViewPercentage : Number($data.avgLoggedInViewPercentage).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2}) + '%'"></span>
                                                </td>
                                            </tr>
                                        <!-- /ko -->

                                    </tbody>
                                <!-- /ko -->

                                <!-- ko if: viewMode() == 'brands' -->
                                    <thead>
                                        <tr>
                                            <th>
                                                <span data-bind="text: getDimensionNiceName()"></span>
                                            </th>
                                            <th data-bind="visible: hasActiveComparison()">
                                                <span style="color: #D8366D !important" data-bind="text: 'Total Comp'"></span>
                                            </th>
                                            <th>
                                                <span data-bind="text: 'Total'"></span>
                                            </th>
                                            <!-- ko foreach: brandHeaders() -->
                                                <th data-bind="visible: $parent.hasActiveComparison() && $parent.comparisonSimplifyToggle()">
                                                    <span style="color: #D8366D !important" data-bind="text: $data + ' Comp'"></span>
                                                </th>

                                                <th>
                                                    <span data-bind="text: $data"></span>
                                                </th>
                                            <!-- /ko -->
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <!-- ko if : Object.keys(brandsTotalsPerDimension).length > 0 -->
                                            <tr class="total-row"">
                                                <td>
                                                    <span data-bind="text: 'Total'"></span>
                                                </td>
                                                <!-- ko with: brandsTotalsPerDimension -->
                                                    <td  data-bind="visible: $parent.hasActiveComparison()">
                                                        <span style="color: #D8366D !important" data-bind="text: isNaN($data.comp) || $data.comp === null ? $data.comp : Number($data.comp).toLocaleString('en-EG', {minimumFractionDigits: 0, maximumFractionDigits: 0})"></span>
                                                        <span style="color: #D8366D !important" class="row-percentage" data-bind="text: isNaN($data.delta) || $data.delta === null ? $data.delta : ' (' + Number($data.delta).toLocaleString('en-EG', {minimumFractionDigits: 1, maximumFractionDigits: 1}) + '%)'"></span>
                                                    </td>
                                                    <td>
                                                        <span data-bind="text: (isNaN($data.value) || $data.value === null) ? $data.value : Number($data.value).toLocaleString('en-EG', {minimumFractionDigits: 0, maximumFractionDigits: 0})"></span>
                                                    </td>

                                                    <!-- ko foreach: brandData -->
                                                        <td data-bind="visible: $parents[1].hasActiveComparison() && $parents[1].comparisonSimplifyToggle()">
                                                            <span style="color: #D8366D !important" data-bind="text: isNaN($data.comp) || $data.comp === null ? $data.comp : Number($data.comp).toLocaleString('en-EG', {minimumFractionDigits: 0, maximumFractionDigits: 0})"></span>
                                                            <span style="color: #D8366D !important" class="row-percentage" data-bind="text: isNaN($data.delta) || $data.delta === null ? $data.delta : ' (' + Number($data.delta).toLocaleString('en-EG', {minimumFractionDigits: 1, maximumFractionDigits: 1}) + '%)'"></span>
                                                        </td>
                                                        <td>
                                                            <span data-bind="text: isNaN($data.value) || $data.value === null ? $data.value : Number($data.value).toLocaleString('en-EG', {minimumFractionDigits: 0, maximumFractionDigits: 0})"></span>
                                                        </td>

                                                    <!-- /ko -->
                                                <!-- /ko -->
                                            </tr>
                                        <!-- /ko -->

                                        <!-- ko foreach: brandsDataPerDimension -->
                                            <tr data-bind="event: { click: $parent.onClickRowClick.bind($data, $index(), $data)}, style: { 'background-color': $parent.selectedRows().indexOf($index()) !== -1 ? '#dbdbed' : '' }">
                                                <td>
                                                    <span class="align-left no-wrap" data-bind="text: $parent.formatDimensionValue(dimension, $parent.dimensionGroupSwitch())"></span>
                                                </td>
                                                <td data-bind="visible: $parent.hasActiveComparison()">
                                                    <span style="color: #D8366D !important" data-bind="text: isNaN($data.comp) || $data.comp === null ? $data.comp : Number($data.comp).toLocaleString('en-EG', {minimumFractionDigits: 0, maximumFractionDigits: 0})"></span>
                                                    <span style="color: #D8366D !important" class="row-percentage" data-bind="text: isNaN($data.delta) || $data.delta === null ? $data.delta : ' (' + Number($data.delta).toLocaleString('en-EG', {minimumFractionDigits: 1, maximumFractionDigits: 1}) + '%)'"></span>
                                                </td>
                                                <td>
                                                    <span data-bind="text: isNaN($data.value) || $data.value === null ? $data.value : Number($data.value).toLocaleString('en-EG', {minimumFractionDigits: 0, maximumFractionDigits: 0})"></span>
                                                    <!-- ko if: $parent.dimensionGroupSwitch() != 'time' -->
                                                        <span class="row-percentage" data-bind="text: isNaN(trafficPercentage) || trafficPercentage === null ? trafficPercentage : ' (' + Number(trafficPercentage).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2}) + '%)'"></span>
                                                    <!-- /ko -->
                                                </td>
                                                <!-- ko foreach: brandData -->

                                                    <td data-bind="visible: $parents[1].hasActiveComparison() && $parents[1].comparisonSimplifyToggle()">
                                                        <span style="color: #D8366D !important" data-bind="text: isNaN($data.comp) || $data.comp === null ? $data.comp : Number($data.comp).toLocaleString('en-EG', {minimumFractionDigits: 0, maximumFractionDigits: 0})"></span>
                                                        <span style="color: #D8366D !important" class="row-percentage" data-bind="text: isNaN($data.delta) || $data.delta === null ? $data.delta : ' (' + Number($data.delta).toLocaleString('en-EG', {minimumFractionDigits: 1, maximumFractionDigits: 1}) + '%)'"></span>
                                                    </td>

                                                    <td>
                                                        <span data-bind="text: isNaN($data.value) || $data.value === null ? $data.value : Number($data.value).toLocaleString('en-EG', {minimumFractionDigits: 0, maximumFractionDigits: 0})"></span>
                                                        <!-- ko if: $parents[1].dimensionGroupSwitch() != 'time' -->
                                                            <span class="row-percentage" data-bind="text: isNaN(trafficPercentage) || trafficPercentage === null ? trafficPercentage : ' (' + Number(trafficPercentage).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2}) + '%)'"></span>
                                                        <!-- /ko -->
                                                    </td>

                                                <!-- /ko -->
                                            </tr>
                                        <!-- /ko -->


                                    </tbody>
                                <!-- /ko -->
                            </table>
                        </div>

                    </div>

                </div>
            </div>
            <footer class="default-footer">
                <span class="logo-short"></span>
                <span class="footer-text">©${new Date().getFullYear()} ValServ Inc. All rights reserved.</span>
                <span>|</span>
                <a href="https://sentinelpro.com/pages/privacy-policy" target="_blank">Privacy Policy</a>
            </footer>
        `;
    }

    /**
     * @inheritDoc
     */
    protected initPartial(): void{

        this.presetFilter = new presetFilter_template("presetFilter", this.getTemplateViewModel(), this.caller);
        this.presetFilter.setType('audienceOverview');

        this.pagination = new pagination_template('pagination', this.getTemplateViewModel(), this.caller);
        this.pagination.getTemplateViewModel().itemPerPage = 50;

        this.brandFilter = new filterSingle_multiLevel_selector_template('brandFilter', this.getTemplateViewModel(), this.caller);
        this.brandFilter.setLabel('Property');
        this.brandFilter.setAllOptionsText('Network');
        this.brandFilter.setHasLogo(true);
        this.brandFilter.setDefaultLogo(vnApp_sentinelbi.BRAND_DEFAULT_ICON_PATH);
        //this.brandFilter.setSelectedOptionText('Network');

        this.viewModeFilter = new filterDropdown_template('viewModeFilter', this.getTemplateViewModel(), this.caller);

        this.multiSegmentsFilter = new multipleSelector_template("multiSegmentsFilter", this.getTemplateViewModel(), this.caller);
        this.multiSegmentsFilter.setLabel('Segments');
        this.multiSegmentsFilter.setTagContainerId('selected-segments');
        this.multiSegmentsFilter.setTagContainerCaption('Selected segments:');

        this.exportDataCsv = new exportDataCsv();

        this.segmentsFilter = new filterDropdown_template('segmentsFilter', this.getTemplateViewModel(), this.caller);

        this.resultsInfo  = new resultsInfo_template('resultsInfo', this.getTemplateViewModel(), this.caller);

        let date = new Date();
        date.setHours(0,0,0,0);
        let firstOfMonth = new Date(date.getFullYear(),date.getMonth(), 1);

        // if it is the first day of the month, we display data from the last month
        if(date.getTime() === firstOfMonth.getTime()){
            firstOfMonth = new Date(date.getFullYear(),date.getMonth() - 1, 1);
            date.setDate(date.getDate() - 1);
        }else{
            date.setDate(date.getDate() - 1);
        }

        this.dateRangeFilter = new filterDate_template("dateRangeFilter", this.getTemplateViewModel(), this.caller);
        this.dateRangeFilter.setStartPickerId('dateRangeStartDatePicker');
        this.dateRangeFilter.setEndPickerId('dateRangeEndDatePicker');
        this.dateRangeFilter.setDateRange(firstOfMonth, date);

        this.compareFilter = new filterSingle_multiLevel_selector_template('compareFilter', this.getTemplateViewModel(), this.caller);
        this.compareFilter.setLabel('Compare');

        this.graphMetricFilter = new filterSingle_multiLevel_selector_template('graphMetricFilter', this.getTemplateViewModel(), this.caller);
        this.graphMetricFilter.setLabel('Metrics');

        this.tableMetricFilter = new filterSingle_multiLevel_selector_template('tableMetricFilter', this.getTemplateViewModel(), this.caller);
        this.tableMetricFilter.setLabel('Metrics');

        this.compRangeFilter = new filterDate_template("compRangeFilter", this.getTemplateViewModel(), this.caller);
        this.compRangeFilter.setLabel('Comparison Date Range');
        this.compRangeFilter.setStartPickerId('compRangeStartDatePicker');
        this.compRangeFilter.setEndPickerId('compRangeEndDatePicker');

        this.compRangeFilter.setDateRange(null, null);

        window.addEventListener('click', event => {

            const sidebarFilters = document.querySelector('.sidebar-filters-js-only');
            const addFiltersDropdown = document.querySelector('.sidebar-default-right');
            const addFiltersButton = document.querySelector('.filterToggle-btn');

            if(!sidebarFilters?.contains(event.target as Element)){
                this.getTemplateViewModel().sidebarToggle(false);
            }

            if(!addFiltersDropdown?.contains(event.target as Element) && !addFiltersButton?.contains(event.target as Element) && !(event.target as Element).closest('.form-auto-item') && !(event.target as Element).closest('.btn-f-s')){
                this.getTemplateViewModel().isFiltersOpen(false);
            }
        })

        this.viewsChart = new amCharts_v4_date_basic_template('viewsChart', this.getTemplateViewModel(), this.caller);

        this.annotationTooltip = new infoButton_template('annotationTooltip', this.getTemplateViewModel(), this.caller)
        this.annotationTooltip.setContent('');
    }

    /**
     * @inheritDoc
     */
    protected getTemplateName(): string{

        return 'audienceOverview_template';
    }

    /**
     * @inheritDoc
     */
    public buildViewModel(): Object{

        let self = this;

        return {
            reportStatusData: ko.observable(),
            sampledDatesData: ko.observableArray([]),
            dynamicFiltersData: ko.observableArray([]),
            dynamicFilters: ko.observableArray([]),
            dynamicFiltersGroupedByName: ko.observableArray([]),
            dynamicFiltersGrouped: ko.observableArray([]),
            customDimensionsNames: ko.observableArray([]),
            graphAxes: ko.observableArray([]),
            graphCompAxes: ko.observableArray([]),
            graphLines: ko.observableArray([]),
            graphCompLines: ko.observableArray([]),
            indicatorsDateRange: ko.observableArray([]),
            indicatorsCompDateRange: ko.observableArray([]),
            timelineAnnotationsData: ko.observableArray([]),
            dimensionsData: ko.observableArray([]),
            dimensionsTotals: ko.observable(),
            dimensionsExportData: ko.observableArray([]),
            dimensionsExportTotals: ko.observable(),
            engagementMetrics: self.getEngagementMetrics(),
            timeGroupSwitch: ko.observable('daily'),
            dimensionGroupSwitch: ko.observable('time'),
            brandHeaders: ko.observableArray([]),
            brandsDataPerDimension: ko.observableArray([]),
            brandsTotalsPerDimension: ko.observable(),
            viewMode: ko.observable('traffic'),
            showAdvancedFilters: ko.observable(false),
            showComparisonDateRange: ko.observable(false),
            indicatorDataLoaded: ko.observable(false),
            compIndicatorDataLoaded: ko.observable(false),
            isPresetVisible: ko.observable(true),
            isVisibleCompareClear: ko.observable(false),
            hasActiveComparison: ko.observable(false),
            comparisonSimplifyToggle: ko.observable(false),
            showEngagementBreakdown: ko.observable(false),
            showAverageViewDuration: ko.observable(false),
            selectedRows: ko.observableArray([]),
            sidebarToggle: ko.observable(false),
            isFiltersOpen: ko.observable(false),
            isPaginationEnabled: ko.observable(false),
            isResultsInfoEnabled: ko.observable(false),
            getDimensionNiceName: function(){

                return self.getDimensionNiceName();
            },
            onClickClearCompareClear: function(data, event){

                self.onClickClearCompareClear();
            },
            toggleEngagementBreakdown: function(){

                self.getTemplateViewModel().showEngagementBreakdown(!self.getTemplateViewModel().showEngagementBreakdown());
            },
            toggleAverageViewDuration: function(){

                self.getTemplateViewModel().showAverageViewDuration(!self.getTemplateViewModel().showAverageViewDuration());
            },
            onTimeGroupSwitch: function(data, event){

                self.onTimeGroupSwitch(data, event);
            },
            onDimensionGroupSwitch: function(data, event){

                self.onDimensionGroupSwitch(data, event);
            },
            onExportData: function(){

                self.onExportData();
            },
            onShowAdvancedFilters: function(){

                self.onShowAdvancedFilters();
            },
            onMouseOverPreset : function () {
                self.onMouseOverPreset();
            },
            onMouseOutPreset : function () {
                self.onMouseOutPreset();
            },
            onClickRowClick: function(index, data){
                self.onClickRowClick(index);
            },
            onComparisonSimplifyToggle: function(){
                self.onComparisonSimplifyToggle();
            },
            formatMinuteSeconds: function(value){
                return self.formatMinuteSeconds(value);
            },
            formatEngagementMetric: function(value, format){
                return self.formatEngagementMetric(value, format);
            },
            formatMetricDelta: function(value){
                return self.formatMetricDelta(value);
            },
            formatDimensionValue: function(value, dimensionGroupSwitch){
                return self.formatDimensionValue(value, dimensionGroupSwitch);
            },
            onSidebarToggle: function(){
                self.onSidebarToggle();
            },
            toggleOpenFilters: function(data){

                self.toggleOpenFilters();
            },
            isTimeGroupDisabled: function(timeGroupSwitch){

                return self.isTimeGroupDisabled(timeGroupSwitch);
            },
            getTimeGroupTitle: function(timeGroupSwitch, label){

                return self.getTimeGroupTitle(timeGroupSwitch, label);
            }
        }
    }

    private getCsvData(){

        this.caller.getListDataForCSV();
    }

    private toggleOpenFilters(){

        this.getTemplateViewModel().isFiltersOpen(!this.getTemplateViewModel().isFiltersOpen());
    }

    private onSidebarToggle(){

        this.getTemplateViewModel().sidebarToggle(!this.getTemplateViewModel().sidebarToggle());
    }

    private formatMinuteSeconds(value){

        if (isNaN(parseInt(value))) {

            return value;
        }else {

            return Math.floor(parseInt(value) / 60) + ":" + (parseInt(value) % 60).toLocaleString('en-US', {
                minimumIntegerDigits: 2,
                useGrouping: false
            });
        }
    }

    private formatEngagementMetric(value, format){

        if (value === null || typeof value === 'undefined' || isNaN(Number(value))) {

            return '-';
        }

        if (format === 'time') {

            return this.formatMinuteSeconds(value);
        }

        if (format === 'percentage') {

            return Number(value).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2}) + '%';
        }

        if (format === 'decimal') {

            return Number(value).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2});
        }

        return Number(value).toLocaleString('en-EG', {minimumFractionDigits: 0, maximumFractionDigits: 0});
    }

    private formatMetricDelta(value){

        return isNaN(value) || value === null ? value : ' (' + Number(value).toLocaleString('en-EG', {minimumFractionDigits: 1, maximumFractionDigits: 1}) + '%)';
    }

    private getEngagementMetrics(){

        return [
            {"field": "viewsPerSession", "countField": null, "name": "PG/S", "format": "decimal"},
            {"field": "engagedVisitPercentage", "countField": "engagedVisitCount", "name": "Eng. Visits", "format": "percentage"},
            {"field": "engaged30SecondsVisitPercentage", "countField": "engaged30SecondsVisitCount", "name": "30s+", "format": "percentage", "isExpandable": true},
            {"field": "engaged60SecondsVisitPercentage", "countField": "engaged60SecondsVisitCount", "name": "60s+", "format": "percentage", "isExpandable": true},
            {"field": "engaged90SecondsVisitPercentage", "countField": "engaged90SecondsVisitCount", "name": "90s+", "format": "percentage", "isExpandable": true},
            {"field": "engagedViewPercentage", "countField": "engagedViewCount", "name": "Eng. Views", "format": "percentage"},
            {"field": "engaged30SecondsViewPercentage", "countField": "engaged30SecondsViewCount", "name": "30s+", "format": "percentage", "isExpandable": true},
            {"field": "engaged60SecondsViewPercentage", "countField": "engaged60SecondsViewCount", "name": "60s+", "format": "percentage", "isExpandable": true},
            {"field": "engaged90SecondsViewPercentage", "countField": "engaged90SecondsViewCount", "name": "90s+", "format": "percentage", "isExpandable": true},
            {"field": "interactionRatio", "countField": null, "name": "Int. Ratio", "format": "percentage"},
            {"field": "timeOnPage", "countField": null, "name": "T<small class=\"metric-unit\">o</small>P", "format": "time"},
        ];
    }

    private formatDimensionValue(value, dimensionGroupSwitch){

        if (value === null || typeof value === 'undefined') {

            return value;
        }

        const displayValue = dimensionGroupSwitch === 'identitySource'
            ? value.toString().replace(/_/g, ' ')
            : value.toString();

        if (dimensionGroupSwitch === 'identitySource') {

            return displayValue
                .split(' ')
                .map(word => word.charAt(0).toUpperCase() + word.slice(1))
                .join(' ');
        }

        return displayValue.charAt(0).toUpperCase() + displayValue.slice(1);
    }

    private onComparisonSimplifyToggle(){

        this.getTemplateViewModel().comparisonSimplifyToggle(!this.getTemplateViewModel().comparisonSimplifyToggle());
    }

    private onClickRowClick(index){

        let selectedRows = this.getTemplateViewModel().selectedRows();
        let check = selectedRows.indexOf(index);
        if (check !== -1) {

            selectedRows.splice(check, 1);
        }else {

            selectedRows.push(index);
        }

        this.getTemplateViewModel().selectedRows(selectedRows);
    }

    public setReportStatusData(reportStatusData) {

        this.getTemplateViewModel().reportStatusData(reportStatusData);
    }

    public setSampledDatesData(sampledDatesData) {

        this.getTemplateViewModel().sampledDatesData(sampledDatesData);
    }

    public setDynamicFilters(dynamicFiltersData: Array<any>) {

        let i = 0;
        let dynamicFilters = [];

        for (let category in dynamicFiltersData) {

            if (dynamicFiltersData.hasOwnProperty(category)) {

                let filtersData = dynamicFiltersData[category];

                filtersData.forEach((filterData) => {

                    let filter, filterId;

                    // multi select
                    if(filterData.type === 'multiSelect'){

                        filterId = filterData.id;
                        filter = new multipleSelector_template(filterId, this.getTemplateViewModel(), this.caller);
                        filter.setLabel(filterData.name);
                        filter.setTagContainerId('selected-' + filterData.name);
                        filter.setTagContainerCaption('Selected ' + filterData.name + ':');
                        filter.setItems(filterData.values);
                        filter.setShowCount(true);
                        filter.setShowClear(true);

                        if(filterData.hasSearchFilter){

                            filter.setContainSearchEnabled(true);
                        }

                        dynamicFilters.push({
                            filter: filter,
                            filterId: filterId,
                            name: filterData.name,
                            type: filterData.type,
                            category: filterData.category,
                            categoryName: filterData.categoryName
                        });
                    }
                    // multi select autocomplete
                    else if(filterData.type === 'autoCompleteMultiSelect'){

                        filterId = filterData.id;
                        filter = new filterMultipleAutoComplete_template(filterId, this.getTemplateViewModel(), this.caller);
                        filter.setIsVisible(1);
                        //filter.setPlaceHolderText(filterData.name);
                        filter.setIcon("i-tag-a");
                        filter.setTagContainerId('selected-' + filterData.name);
                        filter.setTagContainerCaption('Selected ' + filterData.name + ':');
                        filter.setMinInputSuggestionLength(2);
                        filter.setLabel(filterData.name);
                        filter.setShowCount(true);
                        filter.setShowClear(true);


                        if(filterData.hasSearchFilter){

                            filter.setContainSearchEnabled(true);
                        }

                        dynamicFilters.push({
                            filter: filter,
                            filterId: filterId,
                            name: filterData.name,
                            type: filterData.type,
                            category: filterData.category,
                            categoryName: filterData.categoryName
                        });
                    }
                    else if(filterData.type === 'searchField'){

                        filterId = filterData.id;
                        filter = new filterSimple_template(filterId, this.getTemplateViewModel(), this.caller);
                        filter.setLabel(filterData.name);

                        dynamicFilters.push({
                            filter: filter,
                            filterId: filterId,
                            name: filterData.name,
                            type: filterData.type,
                            category: filterData.category,
                            categoryName: filterData.categoryName
                        });
                    }
                })
            }
        }

        this.getTemplateViewModel().dynamicFilters(dynamicFilters);

        let dynamicFiltersGrouped = Object.values(dynamicFilters.reduce((acc, item) => {

            // Check if the category already exists
            if (!acc[item.categoryName]) {
                acc[item.categoryName] = {
                    categoryName: item.categoryName,
                    names: {}
                };
            }

            // Check if the name already exists within the category
            if (!acc[item.categoryName].names[item.name]) {
                acc[item.categoryName].names[item.name] = {
                    name: item.name,
                    filters: []
                };
            }

            // Push the filter into the correct name group
            acc[item.categoryName].names[item.name].filters.push({
                type: item.type,
                filter: item.filter,
                filterId: item.filterId
            });

            return acc;
        }, {}));

        this.getTemplateViewModel().dynamicFiltersGrouped(dynamicFiltersGrouped);

        let dynamicFiltersGroupedByName = Object.values(dynamicFilters.reduce((acc, item) => {

            if (!acc[item.name]) {
                acc[item.name] = { name: item.name, category: item.category, filters: [] };
            }
            acc[item.name].filters.push({ type: item.type, filter: item.filter, filterId: item.filterId });
            return acc;
        }, {}));

        this.getTemplateViewModel().dynamicFiltersGroupedByName(dynamicFiltersGroupedByName);

        // Custom dimension names
        let customDimensionsNames = dynamicFilters.reduce((acc, item) => {
            if (item.category === "Custom Dimensions" && !acc.find(obj => obj.name === item.name)) {
                acc.push({ name: item.name });
            }
            return acc;
        }, []);

        this.getTemplateViewModel().customDimensionsNames(customDimensionsNames);
    }

    public setDynamicAutoCompleteMultiSelectFilterItems(filterId, items){

        let dynamicFilters = this.getTemplateViewModel().dynamicFilters();
        let filter = dynamicFilters.find(filters => filters.filter.idElement === filterId).filter;
        if (filter) {

            filter.setItems(items);
            this.getTemplateViewModel().dynamicFilters(dynamicFilters);
        }
        filter.setItems(items);
    }

    /**
     * @inheritDoc
     */
    public getViewModelForRequest(): Object{

        this.updateTimeGroupAvailability();

        let selectedDynamicFilters = [];
        let dynamicFilters = this.getTemplateViewModel().dynamicFilters();
        if(typeof dynamicFilters !== "undefined" && dynamicFilters !== null && Object.keys(dynamicFilters).length !== 0) {

            for(let dynamicFilter of dynamicFilters) {

                if(dynamicFilter.type === 'multiSelect') {

                    let items = dynamicFilter.filter.getTemplateViewModel().items();
                    let searchKeyword = dynamicFilter.filter.getContainSearchFilterKeyword();
                    let selectedIds = dynamicFilter.filter.getTemplateViewModel().selectedItems();
                    let filteredItems = items.filter(item => selectedIds.includes(item.id));

                    if(filteredItems.length > 0 || searchKeyword) {

                        selectedDynamicFilters.push({

                            [dynamicFilter.category]: {

                                [dynamicFilter.name]: {

                                    id: dynamicFilter.filterId,
                                    type: dynamicFilter.type,
                                    items: filteredItems,
                                    keyword: searchKeyword
                                }
                            }
                        });
                    }
                }
                else if(dynamicFilter.type === 'autoCompleteMultiSelect') {

                    let selectedIds = dynamicFilter.filter.getTemplateViewModel().selectedItems();
                    let searchKeyword = dynamicFilter.filter.getContainSearchFilterKeyword();
                    let filteredItems = selectedIds;

                    if(filteredItems.length > 0 || searchKeyword) {

                        selectedDynamicFilters.push({

                            [dynamicFilter.category]: {

                                [dynamicFilter.name]: {

                                    id: dynamicFilter.filterId,
                                    type: dynamicFilter.type,
                                    items: filteredItems,
                                    keyword: searchKeyword
                                }
                            }
                        });
                    }
                }
                else if(dynamicFilter.type === 'searchField') {

                    let searchKeyword = dynamicFilter.filter.getTemplateViewModel().filterKeyword();

                    if(searchKeyword) {

                        selectedDynamicFilters.push({

                            [dynamicFilter.category]: {
                                [dynamicFilter.name]: {
                                    id: dynamicFilter.filterId,
                                    type: dynamicFilter.type,
                                    keyword: searchKeyword
                                }
                            }
                        });
                    }
                }
            }
        }

        return {
            filters : {
                selectedDynamicFilters: selectedDynamicFilters,
                selectedBrand: this.brandFilter.getTemplateViewModel().selectedOption(),
                selectedBrandText: this.brandFilter.getTemplateViewModel().selectedOptionText(),
                dateFilterType: this.getTemplateViewModel().dateRangeFilter.selectedFilter(),
                selectedMonth: this.getTemplateViewModel().dateRangeFilter.selectedMonth(),
                selectedWeek: this.getTemplateViewModel().dateRangeFilter.selectedWeek(),
                startDate: this.getTemplateViewModel().dateRangeFilter.startDate(),
                endDate: this.getTemplateViewModel().dateRangeFilter.endDate(),
                startDateRange: this.getTemplateViewModel().dateRangeFilter.fromRange(),
                endDateRange: this.getTemplateViewModel().dateRangeFilter.toRange(),
                compare: this.getTemplateViewModel().compareFilter.selectedOption(),
                compDateFilterType: this.getTemplateViewModel().compRangeFilter.selectedFilter(),
                compSelectedMonth: this.getTemplateViewModel().compRangeFilter.selectedMonth(),
                compSelectedWeek: this.getTemplateViewModel().compRangeFilter.selectedWeek(),
                compStartDate: this.getTemplateViewModel().compRangeFilter.startDate(),
                compEndDate: this.getTemplateViewModel().compRangeFilter.endDate(),
                compStartDateRange: this.getTemplateViewModel().compRangeFilter.fromRange(),
                compEndDateRange: this.getTemplateViewModel().compRangeFilter.toRange(),
                showComparisonDateRange: this.getTemplateViewModel().showComparisonDateRange(),
                indicatorGroupSwitch: this.getTemplateViewModel().graphMetricFilter.selectedOption(),
                indicatorGroupSwitchText: this.getTemplateViewModel().graphMetricFilter.selectedOptionText(),
                timeGroupSwitch: this.getTemplateViewModel().timeGroupSwitch(),
                dimensionGroupSwitch: this.getAudienceOverviewDimensionGroupSwitch(this.getTemplateViewModel().dimensionGroupSwitch()),
                viewMode: this.getTemplateViewModel().tableMetricFilter.selectedOption(),
                viewModeText: this.getTemplateViewModel().tableMetricFilter.selectedOptionText(),
                pagination: this.getTemplateViewModel().pagination
            }
        };
    }

    public updatePagination(totalCount){

        this.pagination.setNumberItemToPaginate(totalCount);
    }

    public onClickClearCompareClear(): void{

        this.compareFilter.setSelectedOption(this.compareFilter.getTemplateViewModel().groups()[0].id);
        this.compareFilter.setSelectedOptionText(this.compareFilter.getTemplateViewModel().groups()[0].name)
        this.processCompareOptions();
        this.caller.getReportData();
    }

    public updateViewMode(): void{

        this.getTemplateViewModel().viewMode(this.getTemplateViewModel().tableMetricFilter.selectedOption());
    }

    public processCompareOptions(): void{

        let compareOption = this.compareFilter.getTemplateViewModel().selectedOption();

        if (compareOption == 0) {

            this.getTemplateViewModel().isVisibleCompareClear(false);
            this.compRangeFilter.reset();
        } else {

            this.getTemplateViewModel().isVisibleCompareClear(true);
        }

        if (compareOption == 5) {

            this.getTemplateViewModel().showComparisonDateRange(true);
        }else {

            this.getTemplateViewModel().showComparisonDateRange(false);
        }

        if (compareOption >= 1 && compareOption <= 4) {

            let compareDates = this.dateRangeFilter.getComparePeriod(compareOption);
            this.presetFilter.setDates(this.compRangeFilter, 'dates', compareDates.start, compareDates.end, null, null, null, null);
        }

        let compStartDate = this.getTemplateViewModel().compRangeFilter.startDate();
        let compEndDate = this.getTemplateViewModel().compRangeFilter.endDate();

        if (compStartDate !== null && compEndDate !== null) {

            this.getTemplateViewModel().hasActiveComparison(true);
        }else {

            this.getTemplateViewModel().hasActiveComparison(false);
        }
    }

    public compRangeSelected(): boolean{

        return this.getTemplateViewModel().compRangeFilter.startDate()!==null && this.getTemplateViewModel().compRangeFilter.endDate()!==null && this.getTemplateViewModel().dimensionGroupSwitch() == 'time';
    }

    public indicatorsAllDataLoaded(): boolean{

        return (!this.compRangeSelected() && this.getTemplateViewModel().indicatorDataLoaded()) || (this.getTemplateViewModel().indicatorDataLoaded() && this.getTemplateViewModel().compIndicatorDataLoaded());
    }

    /**
     * Build the date Picker calendar.
     */
    public buildDatePickerCalendar() {

        this.dateRangeFilter.buildCalendar();
        this.compRangeFilter.buildCalendar();
        this.setCompareFilterItems();
    }

    public setIndicatorDataLoaded(value){

        this.getTemplateViewModel().indicatorDataLoaded(value);
    }

    public setIndicatorsData(indicatorsData) {

        // convert strings to date objects for am4charts
        for(let i = 0; i < indicatorsData.dateRange.data.length; i++) {

            indicatorsData.dateRange.data[i].date = new Date(indicatorsData.dateRange.data[i].date);
        }

        this.getTemplateViewModel().graphAxes(indicatorsData.graphAxes);
        this.getTemplateViewModel().graphLines(indicatorsData.graphLines);
        this.getTemplateViewModel().indicatorsDateRange(indicatorsData.dateRange);
    }

    public setTimelineAnnotationsData(timelineAnnotationsData, axis) {

        let timelineAnnotations = this.getTemplateViewModel().timelineAnnotationsData();

        for(let i = 0; i < timelineAnnotationsData.length; i++) {

            timelineAnnotationsData[i].dateOrig = timelineAnnotationsData[i].date;
            timelineAnnotationsData[i].date = new Date(timelineAnnotationsData[i].date);
            timelineAnnotationsData[i].axis = axis;

            timelineAnnotations.push(timelineAnnotationsData[i]);
        }

        // sort based on the date
        timelineAnnotations.sort((a, b) => a.date.getTime() - b.date.getTime());

        this.getTemplateViewModel().timelineAnnotationsData(timelineAnnotations);

        //remove duplicates
        timelineAnnotations = Array.from(
            new Map(timelineAnnotations.map(u => [u.id, u])).values()
        );

        // format for tooltip
        let formattedAnnotationTooltip = '<ul>';
        for(let i = 0; i < timelineAnnotations.length; i++) {

            let formattedDate = timelineAnnotations[i].dateOrig.substring(0, 10)
            if (this.getTemplateViewModel().timeGroupSwitch() == "hourly") {

                formattedDate = timelineAnnotations[i].dateOrig.substring(0, 13)+'H'
            }
            formattedAnnotationTooltip += '<li class="col"><strong>' + formattedDate + '</strong><p>'+ timelineAnnotations[i].annotation +'</p></li>';
        }
        formattedAnnotationTooltip += '</ul>';


        this.annotationTooltip.setContent(formattedAnnotationTooltip);
    }

    public clearTimelineAnnotatonData(){

        this.getTemplateViewModel().timelineAnnotationsData([]);
    }

    public clearIndicatorData(){

        this.getTemplateViewModel().graphAxes(null);
        this.getTemplateViewModel().graphLines(null);
        this.getTemplateViewModel().indicatorsDateRange(null);
    }

    public setCompIndicatorDataLoaded(value){

        this.getTemplateViewModel().compIndicatorDataLoaded(value);
    }

    public setCompIndicatorsData(indicatorsData) {

        // convert strings to date objects for am4charts
        for(let i = 0; i < indicatorsData.dateRange.data.length; i++) {

            indicatorsData.dateRange.data[i].comp_date = new Date(indicatorsData.dateRange.data[i].comp_date);
        }

        this.getTemplateViewModel().graphCompAxes(indicatorsData.graphAxes);
        this.getTemplateViewModel().graphCompLines(indicatorsData.graphLines);
        this.getTemplateViewModel().indicatorsCompDateRange(indicatorsData.dateRange);
    }

    public clearCompIndicatorData(){

        this.getTemplateViewModel().graphCompAxes(null);
        this.getTemplateViewModel().graphCompLines(null);
        this.getTemplateViewModel().indicatorsCompDateRange(null);
    }

    public setBrandFilterItems(portfolios): void{

        let groups = [];

        this.brandFilter.setIncludeAllOptions(true);

        for(let portfolio of portfolios){

            let subGroups = [];

            let portfolioItem = {"id": portfolio.id, "name": portfolio.name, "cssClasses": portfolio.logo, "type": 'portfolio'};

            if (!(typeof(portfolio.disabled) !== 'undefined' && portfolio.disabled === true)){

                groups.push(portfolioItem);

                for(let brand of portfolio.brands){

                    let brandItem = {"id": brand.id, "name": brand.name, "cssClasses": brand.logo, "iconUrl": brand.logoUrl, "type": 'brand'};

                    subGroups.push(brandItem);
                }
                portfolioItem['subGroups'] = subGroups;
            }else{

                for(let brand of portfolio.brands){

                    let brandItem = {"id": brand.id, "name": brand.name, "cssClasses": brand.logo, "iconUrl": brand.logoUrl, "type": 'brand'};
                    groups.push(brandItem);

                }
            }

        }

        // call setGroups function

        this.brandFilter.setGroups(groups);
        //this.brandFilter.setSelectedOption('all');
    }

    public setCompareFilterItems() {

        const options = this.dateRangeFilter.getCompareOptions();

        let filterItems = options.map(o => {return {
            id: o.id,
            name: o.name,
            type: "",
            cssClasses: ""
        }});

        // set the groups manually (dont use setGroups here)
        this.compareFilter.getTemplateViewModel().groups(filterItems);

        // set default
        this.compareFilter.setSelectedOption(filterItems[0].id);
        this.compareFilter.setSelectedOptionText(filterItems[0].name);
    }

    public setViewModeFilterItems(viewModes): void{

        this.viewModeFilter.setOptions(viewModes);
    }

    public setDefaultDevices(){

        // Select by default Mobile, Desktop, Tablet
        const filter = this.getTemplateViewModel().dynamicFilters().find(f => f.filterId == 'device-internalDimension').filter;

        let defaultDevices = ['Mobile', 'Desktop', 'Tablet'];
        let filterItems = filter.getItems().filter(i => i && defaultDevices.includes(i.name));
        let filterItemIds = filterItems.map(i => i.id);

        if(filter.getTemplateName() === 'multiSelector-template'){

            filter.setSelectedItems(filterItems);
            filter.setTags(filterItemIds, filter.getItems());
        }
    }

    public setSegmentsFilterItems(segments): void{

        this.segmentsFilter.setOptions(segments);
    }

    public onTimeGroupSwitch(data, event){

        if (this.isTimeGroupDisabled(data)) {

            return;
        }

        this.getTemplateViewModel().timeGroupSwitch(data);
        this.caller.getReportData();
    }

    public updateTimeGroupAvailability(): boolean{

        let selectedTimeGroup = this.getTemplateViewModel().timeGroupSwitch();
        if(!this.isTimeGroupDisabled(selectedTimeGroup)){

            return false;
        }

        let fallbackTimeGroup = ['daily', 'weekly', 'monthly', 'hourly'].find(timeGroup => !this.isTimeGroupDisabled(timeGroup));
        if(fallbackTimeGroup){

            this.getTemplateViewModel().timeGroupSwitch(fallbackTimeGroup);
            return true;
        }

        return false;
    }

    public isTimeGroupDisabled(timeGroupSwitch): boolean{

        let startDate = this.getTemplateViewModel().dateRangeFilter.startDate();
        let endDate = this.getTemplateViewModel().dateRangeFilter.endDate();

        return !this.isDateDifferenceWithinMonths(startDate, endDate, this.getTimeGroupMaxMonthsInRange(timeGroupSwitch));
    }

    public getTimeGroupTitle(timeGroupSwitch, label): string{

        if(!this.isTimeGroupDisabled(timeGroupSwitch)){

            return label;
        }

        return label + ' unavailable for ranges over ' + this.getTimeGroupMaxMonthsInRange(timeGroupSwitch) + ' months';
    }

    public onDimensionGroupSwitch(data, event){

        this.getTemplateViewModel().dimensionGroupSwitch(this.getAudienceOverviewDimensionGroupSwitch(data));
        this.caller.getReportData();
    }

    public onShowAdvancedFilters(){

        this.getTemplateViewModel().showAdvancedFilters(!this.getTemplateViewModel().showAdvancedFilters());
    }

    protected onMouseOverPreset(){

        this.getTemplateViewModel().isPresetVisible(true);
    }

    protected onMouseOutPreset(){

        this.getTemplateViewModel().isPresetVisible(false);
    }

    public onExportData(){

        let exportDataView = [];

        if(this.getTemplateViewModel().tableMetricFilter.selectedOption() === 'traffic'){

            this.getCsvData();
        } else if(this.getTemplateViewModel().tableMetricFilter.selectedOption() === 'brands') {

            exportDataView = this.generateCSVForBrands();
            this.exportDataCsv.exportToCsv("audience_overview_export", exportDataView);
        }
    }

    private generateCSVForTraffic(){

        let exportDataView = [];

        for (let exportDataRow of this.getTemplateViewModel().dimensionsExportData()) {

            let exportDataViewRow = [];

            exportDataViewRow["Dimension"] = exportDataRow.dimension;
            exportDataViewRow["Sessions"] = Number(exportDataRow.sessionCount).toLocaleString('en-EG', {minimumFractionDigits: 0, maximumFractionDigits: 0});
            exportDataViewRow["Visits"] = Number(exportDataRow.visitCount).toLocaleString('en-EG', {minimumFractionDigits: 0, maximumFractionDigits: 0});
            exportDataViewRow["Views"] = Number(exportDataRow.viewCount).toLocaleString('en-EG', {minimumFractionDigits: 0, maximumFractionDigits: 0});
            exportDataViewRow["Engaged Visits %"] = this.formatEngagementMetric(exportDataRow.engagedVisitPercentage, 'percentage');
            exportDataViewRow["Engaged Visits (count)"] = this.formatEngagementMetric(exportDataRow.engagedVisitCount, 'count');
            exportDataViewRow["Engaged Views %"] = this.formatEngagementMetric(exportDataRow.engagedViewPercentage, 'percentage');
            exportDataViewRow["Engaged Views (count)"] = this.formatEngagementMetric(exportDataRow.engagedViewCount, 'count');
            exportDataViewRow["Engaged Visits 30s %"] = this.formatEngagementMetric(exportDataRow.engaged30SecondsVisitPercentage, 'percentage');
            exportDataViewRow["Engaged Visits 30s (count)"] = this.formatEngagementMetric(exportDataRow.engaged30SecondsVisitCount, 'count');
            exportDataViewRow["Engaged Views 30s %"] = this.formatEngagementMetric(exportDataRow.engaged30SecondsViewPercentage, 'percentage');
            exportDataViewRow["Engaged Views 30s (count)"] = this.formatEngagementMetric(exportDataRow.engaged30SecondsViewCount, 'count');
            exportDataViewRow["Engaged Visits 60s %"] = this.formatEngagementMetric(exportDataRow.engaged60SecondsVisitPercentage, 'percentage');
            exportDataViewRow["Engaged Visits 60s (count)"] = this.formatEngagementMetric(exportDataRow.engaged60SecondsVisitCount, 'count');
            exportDataViewRow["Engaged Views 60s %"] = this.formatEngagementMetric(exportDataRow.engaged60SecondsViewPercentage, 'percentage');
            exportDataViewRow["Engaged Views 60s (count)"] = this.formatEngagementMetric(exportDataRow.engaged60SecondsViewCount, 'count');
            exportDataViewRow["Engaged Visits 90s %"] = this.formatEngagementMetric(exportDataRow.engaged90SecondsVisitPercentage, 'percentage');
            exportDataViewRow["Engaged Visits 90s (count)"] = this.formatEngagementMetric(exportDataRow.engaged90SecondsVisitCount, 'count');
            exportDataViewRow["Engaged Views 90s %"] = this.formatEngagementMetric(exportDataRow.engaged90SecondsViewPercentage, 'percentage');
            exportDataViewRow["Engaged Views 90s (count)"] = this.formatEngagementMetric(exportDataRow.engaged90SecondsViewCount, 'count');
            exportDataViewRow["Time on Page (mm:ss)"] = this.formatEngagementMetric(exportDataRow.timeOnPage, 'time');
            exportDataViewRow["Interaction Ratio"] = this.formatEngagementMetric(exportDataRow.interactionRatio, 'percentage');
            exportDataViewRow["PG/S"] = Number(exportDataRow.viewsPerSession).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2});
            exportDataViewRow["AVD (mm:ss)"] = exportDataRow.avgViewEngagedSeconds;
            exportDataViewRow["Scroll Depth %"] = Number(exportDataRow.avgViewEngagedDepthPercentage).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2});
            exportDataViewRow["Avg Speed (Mbps)"] = Number(exportDataRow.avgConnectionSpeed).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2});
            exportDataViewRow["Logged In Sessions (%)"] = Number(exportDataRow.avgLoggedInSessionPercentage).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2});
            exportDataViewRow["Logged In Visits (%)"] = Number(exportDataRow.avgLoggedInVisitPercentage).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2});
            exportDataViewRow["Logged In Views (%)"] = Number(exportDataRow.avgLoggedInViewPercentage).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2});

            exportDataView.push(exportDataViewRow);
        }

        let exportDataRow = this.getTemplateViewModel().dimensionsExportTotals();

        let exportDataTotalViewRow = [];

        exportDataTotalViewRow["Dimension"] = 'Total';
        exportDataTotalViewRow["Sessions"] = Number(exportDataRow.sessionCount).toLocaleString('en-EG', {minimumFractionDigits: 0, maximumFractionDigits: 0});
        exportDataTotalViewRow["Visits"] = Number(exportDataRow.visitCount).toLocaleString('en-EG', {minimumFractionDigits: 0, maximumFractionDigits: 0});
        exportDataTotalViewRow["Views"] = Number(exportDataRow.viewCount).toLocaleString('en-EG', {minimumFractionDigits: 0, maximumFractionDigits: 0});
        exportDataTotalViewRow["Engaged Visits %"] = this.formatEngagementMetric(exportDataRow.engagedVisitPercentage, 'percentage');
        exportDataTotalViewRow["Engaged Visits (count)"] = this.formatEngagementMetric(exportDataRow.engagedVisitCount, 'count');
        exportDataTotalViewRow["Engaged Views %"] = this.formatEngagementMetric(exportDataRow.engagedViewPercentage, 'percentage');
        exportDataTotalViewRow["Engaged Views (count)"] = this.formatEngagementMetric(exportDataRow.engagedViewCount, 'count');
        exportDataTotalViewRow["Engaged Visits 30s %"] = this.formatEngagementMetric(exportDataRow.engaged30SecondsVisitPercentage, 'percentage');
        exportDataTotalViewRow["Engaged Visits 30s (count)"] = this.formatEngagementMetric(exportDataRow.engaged30SecondsVisitCount, 'count');
        exportDataTotalViewRow["Engaged Views 30s %"] = this.formatEngagementMetric(exportDataRow.engaged30SecondsViewPercentage, 'percentage');
        exportDataTotalViewRow["Engaged Views 30s (count)"] = this.formatEngagementMetric(exportDataRow.engaged30SecondsViewCount, 'count');
        exportDataTotalViewRow["Engaged Visits 60s %"] = this.formatEngagementMetric(exportDataRow.engaged60SecondsVisitPercentage, 'percentage');
        exportDataTotalViewRow["Engaged Visits 60s (count)"] = this.formatEngagementMetric(exportDataRow.engaged60SecondsVisitCount, 'count');
        exportDataTotalViewRow["Engaged Views 60s %"] = this.formatEngagementMetric(exportDataRow.engaged60SecondsViewPercentage, 'percentage');
        exportDataTotalViewRow["Engaged Views 60s (count)"] = this.formatEngagementMetric(exportDataRow.engaged60SecondsViewCount, 'count');
        exportDataTotalViewRow["Engaged Visits 90s %"] = this.formatEngagementMetric(exportDataRow.engaged90SecondsVisitPercentage, 'percentage');
        exportDataTotalViewRow["Engaged Visits 90s (count)"] = this.formatEngagementMetric(exportDataRow.engaged90SecondsVisitCount, 'count');
        exportDataTotalViewRow["Engaged Views 90s %"] = this.formatEngagementMetric(exportDataRow.engaged90SecondsViewPercentage, 'percentage');
        exportDataTotalViewRow["Engaged Views 90s (count)"] = this.formatEngagementMetric(exportDataRow.engaged90SecondsViewCount, 'count');
        exportDataTotalViewRow["Time on Page (mm:ss)"] = this.formatEngagementMetric(exportDataRow.timeOnPage, 'time');
        exportDataTotalViewRow["Interaction Ratio"] = this.formatEngagementMetric(exportDataRow.interactionRatio, 'percentage');
        exportDataTotalViewRow["PG/S"] = Number(exportDataRow.viewsPerSession).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2});
        exportDataTotalViewRow["AVD (mm:ss)"] = exportDataRow.avgViewEngagedSeconds;
        exportDataTotalViewRow["Scroll Depth %"] = Number(exportDataRow.avgViewEngagedDepthPercentage).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2});
        exportDataTotalViewRow["Avg Speed (Mbps)"] = Number(exportDataRow.avgConnectionSpeed).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2});
        exportDataTotalViewRow["Logged In Sessions (%)"] = Number(exportDataRow.avgLoggedInSessionPercentage).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2});
        exportDataTotalViewRow["Logged In Visits (%)"] = Number(exportDataRow.avgLoggedInVisitPercentage).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2});
        exportDataTotalViewRow["Logged In Views (%)"] = Number(exportDataRow.avgLoggedInViewPercentage).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2});

        exportDataView.push(exportDataTotalViewRow);


        return exportDataView;

    }

    private generateCSVForBrands(){

        let exportDataView = [];

        for (let brandDataPerDimension of this.getTemplateViewModel().brandsDataPerDimension()) {

            let exportDataViewRow = [];

            exportDataViewRow["Dimension"] = brandDataPerDimension.dimension;
            exportDataViewRow["Total"] = Number(brandDataPerDimension.value).toLocaleString('en-EG', {minimumFractionDigits: 0, maximumFractionDigits: 0});

            for(let brandData of brandDataPerDimension.brandData){

                let brandName = brandData.brand;

                exportDataViewRow[brandName] = Number(brandData.value).toLocaleString('en-EG', {minimumFractionDigits: 0, maximumFractionDigits: 0});
            }

            exportDataView.push(exportDataViewRow);
        }


        let exportDataViewRow = [];
        exportDataViewRow["Dimension"] = "Total";

        let brandsTotalsPerDimension = this.getTemplateViewModel().brandsTotalsPerDimension();

        exportDataViewRow["Total"] = Number(brandsTotalsPerDimension.value).toLocaleString('en-EG', {minimumFractionDigits: 0, maximumFractionDigits: 0});

        for (let brandTotalPerDimension of brandsTotalsPerDimension.brandData) {

            let brandName = brandTotalPerDimension.brand;

            exportDataViewRow[brandName] = Number(brandTotalPerDimension.value).toLocaleString('en-EG', {minimumFractionDigits: 0, maximumFractionDigits: 0});

        }
        exportDataView.push(exportDataViewRow);

        return exportDataView;

    }

    public setResultPage(nbResults, nbPages, execTime) {
        this.resultsInfo.setExecutionTime(execTime);
        this.resultsInfo.setNbResults(nbResults);
        this.resultsInfo.setNbPages(nbPages);
    }


    public updateIndicatorsGraphData(){

        this.viewsChart.setCssHeight("300px");
        /*
        if(this.getTemplateViewModel().compRangeFilter.startDate() && this.getTemplateViewModel().compRangeFilter.endDate()){

            this.viewsChart.setNbOfXAxes(2);
        }
        else{

            this.viewsChart.setNbOfXAxes(1);
        } */

        let normalizedLinePoints = [];
        if(this.compRangeSelected()){

            let indicatorsDateRangeCount = this.getTemplateViewModel().indicatorsDateRange().data.length;
            let indicatorsCompDateRangeCount = this.getTemplateViewModel().indicatorsCompDateRange().data.length;

            if(indicatorsDateRangeCount!=indicatorsCompDateRangeCount){

                if(indicatorsCompDateRangeCount > indicatorsDateRangeCount){

                    if(indicatorsDateRangeCount > 0){

                        let date = new Date(this.getTemplateViewModel().indicatorsDateRange().data[indicatorsDateRangeCount-1][this.getTemplateViewModel().graphAxes()]);
                        var userTimezoneOffset = date.getTimezoneOffset() * 60000;

                        for(let i = indicatorsDateRangeCount; i < indicatorsCompDateRangeCount; i++){

                            let newDate;
                            if(this.getTemplateViewModel().timeGroupSwitch() == "hourly") {

                                newDate = date.setHours(date.getHours() + 1);
                                newDate = new Date(date.getTime() - userTimezoneOffset).toISOString().slice(0, 19).replace('T', ' ');
                            }
                            else {

                                newDate = date.setHours(date.getHours() + 24);
                                newDate = new Date(date.getTime()).toISOString().slice(0, 10).replace('T', ' ');
                            }
                            normalizedLinePoints.push({ [this.getTemplateViewModel().graphAxes()]: newDate});
                        }


                        this.getTemplateViewModel().indicatorsDateRange().data.concat(normalizedLinePoints);
                    }
                }
                else {

                    if(indicatorsCompDateRangeCount > 0){

                        let date = new Date(this.getTemplateViewModel().indicatorsCompDateRange().data[indicatorsCompDateRangeCount-1][this.getTemplateViewModel().graphCompAxes()]);
                        var userTimezoneOffset = date.getTimezoneOffset() * 60000;


                        for(let i = indicatorsCompDateRangeCount; i < indicatorsDateRangeCount; i++){

                            let newDate;
                            if(this.getTemplateViewModel().timeGroupSwitch() == "hourly") {

                                newDate = date.setHours(date.getHours() + 1);
                                newDate = new Date(date.getTime() - userTimezoneOffset).toISOString().slice(0, 19).replace('T', ' ');
                            }
                            else {

                                newDate = date.setHours(date.getHours() + 24);
                                newDate = new Date(date.getTime()).toISOString().slice(0, 10).replace('T', ' ');
                            }
                            normalizedLinePoints.push({ [this.getTemplateViewModel().graphCompAxes()]: newDate});
                        }
                        this.getTemplateViewModel().indicatorsCompDateRange().data.concat(normalizedLinePoints);
                    }
                }
            }
        }

        let axes = this.getTemplateViewModel().graphCompAxes() ? this.getTemplateViewModel().graphAxes().concat(this.getTemplateViewModel().graphCompAxes()) : this.getTemplateViewModel().graphAxes();
        let graphLines = (this.getTemplateViewModel().graphCompLines() ? this.getTemplateViewModel().graphLines().concat(this.getTemplateViewModel().graphCompLines()) : this.getTemplateViewModel().graphLines());
        let chartData = this.getTemplateViewModel().indicatorsCompDateRange() ? this.getTemplateViewModel().indicatorsDateRange().data.concat(this.getTemplateViewModel().indicatorsCompDateRange().data).concat(normalizedLinePoints) : this.getTemplateViewModel().indicatorsDateRange().data;

        this.viewsChart.setNbOfXAxes(axes.length)
        this.viewsChart.setDateFormat(this.getTemplateViewModel().timeGroupSwitch());
        this.viewsChart.setDateFields(axes);
        this.viewsChart.setCursorEnabled(1);
        this.viewsChart.setLabelMaxWidth(80);
        this.viewsChart.setAutoRotateLabels(1);
        this.viewsChart.setClickableLegend(1);
        this.viewsChart.setXScrollbarEnabled(0);

        let chart = this.viewsChart.setupChart(chartData);

        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        this.viewsChart.applyValueAxisFormatting(valueAxis);
        valueAxis.renderer.minWidth = 50;
        valueAxis.renderer.grid.template.disabled = true;

        valueAxis.title.fontWeight = "bold";
        valueAxis.min = 0;

        let count = 0;
        for (let graphLine of graphLines) {

            let series = chart.series.push(new am4charts.LineSeries());

            if(axes.length>1){

                series.xAxis = this.viewsChart.getDateAxes()[count];
            }

            let color = audienceOverview_template.getPaletteColor(count);
            if(axes.length>count){

                series.xAxis.renderer.labels.template.fill = am4core.color(color);
            }

            series.dataItems.template.locations.categoryX = 0.5;
            series.dataFields.valueY =  graphLine.value;
            series.dataFields.customValue = graphLine.value;
            series.dataFields.dateX = graphLine.field;
            series.strokeOpacity = 1;
            series.strokeWidth = 2;
            series.fill = am4core.color(color);
            series.stroke = am4core.color(color);
            series.yAxis = valueAxis;
            series.name = graphLine.name;

            series.tooltipText = "{name}: [bold]{customValue}[/]";
            series.smoothing = "monotoneX";
            series.showOnInit = true;

            let interfaceColors = new am4core.InterfaceColorSet();

            let bullet = series.bullets.push(new am4charts.CircleBullet());
            bullet.circle.radius = 4;
            bullet.circle.opacity = 1;
            bullet.circle.strokeWidth = 1;
            bullet.circle.stroke = interfaceColors.getFor("background");
            bullet.circle.opacity = 1;
            bullet.circle.strokeOpacity = 0.9;

            series.minBulletDistance = 2.5;

            if(axes.length > 1 && count > 0) {

                series.xAxis.renderer.labels.template.disabled = true;
                series.xAxis.tooltip!.dy = 30;
            }

            count++;
        }

        chart.events.once("ready", () => {

            for (let annotation of this.getTemplateViewModel().timelineAnnotationsData()) {

                // Use the axis of a known series to choose the correct x-axis (you have multiple).
                const series0 = chart.series.getIndex(annotation.axis) as am4charts.LineSeries;
                if (!series0 || !series0.xAxis) return;

                // Cast the axis to DateAxis so TS knows about min/max, strictMinMax, etc.
                const xAxis = series0.xAxis as am4charts.DateAxis;

                // The moment you want to mark:
                let eventDateTmp = annotation.date;


                let lineOffset = 43200000;
                if (this.getTemplateViewModel().timeGroupSwitch() == "hourly") {

                    lineOffset = 1800000;
                }else {

                    eventDateTmp.setHours(0, 0, 0, 0);
                }

                let offset = (eventDateTmp.getTimezoneOffset() * 60 * 1000);


                let eventDate = new Date(eventDateTmp.getTime() - offset + lineOffset);


                const ts = +eventDate;

                // Create the range and cast it to DateAxisDataItem so .value/.date are valid
                const range = xAxis.axisRanges.create() as am4charts.DateAxisDataItem;

                // Either set value (timestamp) or date (Date) — both are valid on DateAxisDataItem
                range.value = ts;              // or: range.date = eventDate;

                // Style the line
                range.grid.stroke = am4core.color("#FF0000");
                range.grid.strokeWidth = 2;
                range.grid.strokeOpacity = 1;
                range.grid.strokeDasharray = "4,4";
                range.grid.zIndex = 1000;

                // Label / note
                //range.label.text = "Annotation";
                range.label.rotation = -90;
                range.label.horizontalCenter = "right";
                range.label.verticalCenter = "bottom";
                range.label.dy = -150;                     // tweak up/down if needed

                range.label.inside = true;
                range.label.fill = am4core.color("#D41C5C");
                range.label.padding(0, 6, 0, 6);
            }
        });

        if(chart.logo){

            chart.logo.disabled = true;
        }
    }

    public setDimensionsData(dimensionsData, dimensionsTotals) {

        this.getTemplateViewModel().selectedRows([]);

        let dimensionGroupSwitch = this.getTemplateViewModel().dimensionGroupSwitch();
        let timeGroupSwitch = this.getTemplateViewModel().timeGroupSwitch();

        if (dimensionGroupSwitch == 'time') {

            for (let item of dimensionsData) {

                item.dimension = this.formatDate(item.dimension, (timeGroupSwitch == 'hourly'));
            }

        }

        this.getTemplateViewModel().dimensionsTotals(dimensionsTotals);
        this.getTemplateViewModel().dimensionsData(dimensionsData);
    }

    public setBrandsData(brandHeaders, tableData, totals) {

        this.getTemplateViewModel().selectedRows([]);

        let dimensionGroupSwitch = this.getTemplateViewModel().dimensionGroupSwitch();
        let timeGroupSwitch = this.getTemplateViewModel().timeGroupSwitch();

        if (dimensionGroupSwitch == 'time') {

            for (let item of tableData) {

                item.dimension = this.formatDate(item.dimension, (timeGroupSwitch == 'hourly'));
            }
        }

        this.getTemplateViewModel().brandHeaders(brandHeaders);
        this.getTemplateViewModel().brandsDataPerDimension(tableData);
        this.getTemplateViewModel().brandsTotalsPerDimension(totals);
    }

    static getPaletteColor(number) {
        switch(number) {
            case 0:
                return "#312D69";
            case 1:
                return "#D8366D";
            case 2:
                return "#1CA71C"; // Bold Green
            case 3:
                return "#FB0D0D"; // Vivid Red
            case 4:
                return "#DA16FF"; // Purple
            case 5:
                return "#222A2A"; // Dark Gray
            case 6:
                return "#FFC800"; // Bright Yellow
            case 7:
                return "#00C49A"; // Teal
            case 8:
                return "#FF5733"; // Orange-Red
            case 9:
                return "#6A329F"; // Deep Purple
            default:
                return "#000000";  // Default case if number doesn't match any case
        }
    }

    static stringToColour(str){

        let hash = 0;
        for (let i = 0; i < str.length; i++){

            hash = str.charCodeAt(i) + ((hash << 5) - hash);
        }

        let colour = '#';
        for (let i = 0; i < 3; i++){

            let value = (hash >> (i * 8)) & 0xFF;
            colour += ('00' + value.toString(16)).substr(-2);
        }

        return colour;
    }

    private formatDate(date, hours) {

        let weekday = new Array(7);
        weekday[0] = "Sun";
        weekday[1] = "Mon";
        weekday[2] = "Tue";
        weekday[3] = "Wed";
        weekday[4] = "Thu";
        weekday[5] = "Fri";
        weekday[6] = "Sat";

        if (!hours) {

            date = date + " 00:00:00";
        }

        let d = new Date(date);

        let month = '0' + (d.getMonth()+ 1);
        month = month.slice(-2);

        let day = '0' + d.getDate();
        day = day.slice(-2);

        let year = d.getFullYear();
        let dayOfWeek = weekday[d.getDay()];

        let currentHours = '0' + d.getHours();
        currentHours = currentHours.slice(-2);

        return dayOfWeek + ', ' + [year, month, day].join('-') + ((hours) ? ' ' + currentHours + 'h' : '');
    }

    public setGraphMetricsFilterItems() {

        const options = this.graphMetrics;

        let filterItems = options.map(o => {
            return {
                id: o.id,
                name: o.name,
                type: "",
                cssClasses: ""
            }
        });

        // set the groups manually (dont use setGroups here)
        this.graphMetricFilter.getTemplateViewModel().groups(filterItems);

        // set default
        this.graphMetricFilter.setSelectedOption(filterItems[2].id);
        this.graphMetricFilter.setSelectedOptionText(filterItems[2].name);
    }

    public setTableMetricsFilterItems() {

        const options = this.tableMetrics;

        let filterItems = options.map(o => {
            return {
                id: o.id,
                name: o.name,
                type: "",
                cssClasses: ""
            }
        });

        // set the groups manually (dont use setGroups here)
        this.tableMetricFilter.getTemplateViewModel().groups(filterItems);

        // set default
        this.tableMetricFilter.setSelectedOption(filterItems[0].id);
        this.tableMetricFilter.setSelectedOptionText(filterItems[0].name);

        this.getTemplateViewModel().viewMode(filterItems[0].id);
    }

    public setCsvExportData(exportData){

        this.getTemplateViewModel().dimensionsExportData(exportData.tableData);
        this.getTemplateViewModel().dimensionsExportTotals(this.completeEngagementExportTotals(exportData.tableData, exportData.totals));
    }

    private completeEngagementExportTotals(rows, totals){

        let completedTotals = Object.assign({}, totals || {});
        let metricTotals = [
            {"countField": "engagedVisitCount", "percentageField": "engagedVisitPercentage", "denominatorField": "visitCount"},
            {"countField": "engagedViewCount", "percentageField": "engagedViewPercentage", "denominatorField": "viewCount"},
            {"countField": "engaged30SecondsVisitCount", "percentageField": "engaged30SecondsVisitPercentage", "denominatorField": "visitCount"},
            {"countField": "engaged30SecondsViewCount", "percentageField": "engaged30SecondsViewPercentage", "denominatorField": "viewCount"},
            {"countField": "engaged60SecondsVisitCount", "percentageField": "engaged60SecondsVisitPercentage", "denominatorField": "visitCount"},
            {"countField": "engaged60SecondsViewCount", "percentageField": "engaged60SecondsViewPercentage", "denominatorField": "viewCount"},
            {"countField": "engaged90SecondsVisitCount", "percentageField": "engaged90SecondsVisitPercentage", "denominatorField": "visitCount"},
            {"countField": "engaged90SecondsViewCount", "percentageField": "engaged90SecondsViewPercentage", "denominatorField": "viewCount"},
        ];

        for (let metricTotal of metricTotals) {

            let hasCompleteMetricData = rows.length > 0 && rows.every(row =>
                row[metricTotal.countField] !== null &&
                typeof row[metricTotal.countField] !== 'undefined' &&
                !isNaN(Number(row[metricTotal.countField]))
            );

            if (!hasCompleteMetricData) {

                continue;
            }

            if (completedTotals[metricTotal.countField] === null ||
                typeof completedTotals[metricTotal.countField] === 'undefined' ||
                isNaN(Number(completedTotals[metricTotal.countField]))) {

                completedTotals[metricTotal.countField] = rows.reduce(
                    (total, row) => total + Number(row[metricTotal.countField]),
                    0
                );
            }

            if ((completedTotals[metricTotal.percentageField] === null ||
                typeof completedTotals[metricTotal.percentageField] === 'undefined' ||
                isNaN(Number(completedTotals[metricTotal.percentageField]))) &&
                Number(completedTotals[metricTotal.denominatorField]) > 0) {

                completedTotals[metricTotal.percentageField] =
                    completedTotals[metricTotal.countField] /
                    Number(completedTotals[metricTotal.denominatorField]) *
                    100;
            }
        }

        return completedTotals;
    }

    public exportCsvData() {

        let exportDataView = [];

        exportDataView = this.generateCSVForTraffic();

        this.exportDataCsv.exportToCsv("audience_overview_export", exportDataView);
    }

    public setViewModelFromRequest(params : Array<any>): void{

        if(typeof params['selectedBrand'] !== 'undefined'){

            this.brandFilter.getTemplateViewModel().selectedOption(params['selectedBrand']);
        }

        if(typeof params['selectedBrandText'] !== 'undefined'){

            this.brandFilter.getTemplateViewModel().selectedOptionText(params['selectedBrandText']);
        }

        if(typeof params['viewMode'] !== 'undefined'){

            this.tableMetricFilter.setSelectedOption(params['viewMode']);
            this.getTemplateViewModel().viewMode(params['viewMode']);
        }

        if(typeof params['viewModeText'] !== 'undefined'){

            this.tableMetricFilter.setSelectedOptionText(params['viewModeText']);
        }

        if(typeof params['selectedSegment'] !== 'undefined'){

            this.segmentsFilter.getTemplateViewModel().selectedOption(params['selectedSegment']);
        }

        if(typeof params['indicatorGroupSwitch'] !== 'undefined'){

            this.graphMetricFilter.setSelectedOption(params['indicatorGroupSwitch']);
        }

        if(typeof params['indicatorGroupSwitchText'] !== 'undefined'){

            this.graphMetricFilter.setSelectedOptionText(params['indicatorGroupSwitchText']);
        }

        if(typeof params['timeGroupSwitch'] !== 'undefined'){

            this.getTemplateViewModel().timeGroupSwitch(params['timeGroupSwitch']);
        }

        if(typeof params['dimensionGroupSwitch'] !== 'undefined'){

            this.getTemplateViewModel().dimensionGroupSwitch(this.getAudienceOverviewDimensionGroupSwitch(params['dimensionGroupSwitch']));
        }

        if(typeof params['selectedDynamicFilters'] !== 'undefined' && Array.isArray(params['selectedDynamicFilters'])){

            let dynamicFilters = this.getTemplateViewModel().dynamicFilters();

            params['selectedDynamicFilters'].forEach(selectedDynamicFilter => {

                Object.values(selectedDynamicFilter).forEach(category => {

                    if (typeof category === 'object' && category !== null) {

                        Object.values(category).forEach(categoryFilter => {

                            let dynamicFilter = dynamicFilters.find(obj => obj.filter.idElement === categoryFilter.id);

                            if (dynamicFilter) {

                                let filter = dynamicFilter.filter;

                                if(categoryFilter.type === 'multiSelect'){

                                    if(categoryFilter.items.length > 0 || categoryFilter.keyword != ''){

                                        let filterIds = categoryFilter.items.map(obj => obj.id);
                                        this.presetFilter.setMultiSelectorPresetFilters(filter, filterIds, categoryFilter.keyword);
                                    }
                                }
                                else if(categoryFilter.type === 'autoCompleteMultiSelect'){

                                    if(categoryFilter.items.length > 0 || categoryFilter.keyword != ''){

                                        let filterIds = categoryFilter.items.map(obj => obj.id);
                                        let filterNames = categoryFilter.items.map(obj => obj.name);
                                        this.presetFilter.setMultipleAutocompletePresetFilter(filter, filterIds, filterNames, categoryFilter.keyword);
                                    }
                                }
                                else if(categoryFilter.type === 'searchField'){

                                    if(categoryFilter.keyword != ''){

                                        filter.getTemplateViewModel().filterKeyword(categoryFilter.keyword);
                                    }

                                }
                            }
                        });
                    }
                });

            });

            this.getTemplateViewModel().dynamicFilters(dynamicFilters);
        }

        this.presetFilter.setDates(this.dateRangeFilter, params['dateFilterType'], params['startDate'], params['endDate'], params['startDateRange'], params['endDateRange'], params['selectedMonth'], params['selectedWeek']);

        this.presetFilter.setDates(this.compRangeFilter, params['compDateFilterType'], params['compStartDate'], params['compEndDate'], params['compStartDateRange'], params['compEndDateRange'], params['compSelectedMonth'], params['compSelectedWeek']);

        if(typeof params['compare'] !== 'undefined'){

            this.compareFilter.setSelectedOption(this.compareFilter.getTemplateViewModel().groups()[params['compare']].id);
            this.compareFilter.setSelectedOptionText(this.compareFilter.getTemplateViewModel().groups()[params['compare']].name);
            this.processCompareOptions();
        }

        this.updateTimeGroupAvailability();
    }

    private isDateDifferenceWithinDays(startDate, endDate, numDays) {

        const dateA = new Date(startDate);
        const dateB = new Date(endDate);

        const diffInMs = Math.abs(dateA.getTime() - dateB.getTime());
        const diffInDays = diffInMs / (1000 * 60 * 60 * 24);

        return (diffInDays + 1) <= numDays;
    }

    private isDateDifferenceWithinMonths(startDate, endDate, numMonths) {

        if(!startDate || !endDate) {

            return true;
        }

        const start = this.parseDate(startDate);
        const end = this.parseDate(endDate);

        if(!start || !end) {

            return true;
        }

        const checkDate = new Date(start.getTime());
        checkDate.setMonth(checkDate.getMonth() + numMonths);

        return end.getTime() <= checkDate.getTime();
    }

    private parseDate(date) {

        if(date instanceof Date) {

            return date;
        }

        let dateParts = String(date).substring(0, 10).split('-').map(part => parseInt(part, 10));
        if(dateParts.length !== 3 || dateParts.some(part => isNaN(part))) {

            return null;
        }

        return new Date(dateParts[0], dateParts[1] - 1, dateParts[2]);
    }

    private getTimeGroupMaxMonthsInRange(timeGroupSwitch): number{

        if(timeGroupSwitch === 'hourly') {

            return this.isNetworkSelected() ? this.hourlyNetworkMaxMonthsInRange : this.hourlyNonNetworkMaxMonthsInRange;
        }

        if(timeGroupSwitch === 'monthly') {

            return this.monthlyMaxMonthsInRange;
        }

        return this.isNetworkSelected() ? this.dailyNetworkMaxMonthsInRange : this.dailyNonNetworkMaxMonthsInRange;
    }

    private isNetworkSelected(): boolean{

        let selectedBrand = this.brandFilter.getTemplateViewModel().selectedOption();

        return !selectedBrand || selectedBrand === 'all';
    }

    private getAudienceOverviewDimensionGroupSwitch(dimensionGroupSwitch){

        // Audience Overview uses dimension tables where the API exposes the referrer bucket as "referrer";
        // "trafficSource" belongs to live/event aggregate tables, so normalize saved links before sending requests.
        return dimensionGroupSwitch === 'trafficSource' ? 'referrer' : dimensionGroupSwitch;
    }

    public getDimensionNiceName(){

        const dimensionGroupSwitch = this.getTemplateViewModel().dimensionGroupSwitch();

        switch(dimensionGroupSwitch){

            case 'time': return 'Date';
            case 'device': return 'Device';
            case 'deviceModel': return 'Device Model';
            case 'os': return 'Operating System';
            case 'browser': return 'Browser';
            case 'browserVersion': return 'Browser Version';
            case 'adBlockerStatus': return 'Ad Block';
            case 'ip': return 'IP Address';
            case 'userAgent': return 'User Agent';
            case 'geo': return 'Geo';
            case 'city': return 'City';
            case 'permalink': return 'Permalink';
            case 'ampStatus': return 'AMP';
            case 'referrer': return 'Referrer';
            case 'trafficSource': return 'Referrer';
            case 'trafficChannel': return 'Traffic Channel';
            case 'hostname': return 'Hostname';
            case 'loginStatus': return 'Login Status';
            case 'plan': return 'Plan';
            case 'identitySource': return 'Identity Source';
            case 'robotName': return 'Robot Name';
            case 'robotCategory': return 'Robot Category';

            default: return dimensionGroupSwitch;
        }
    }
}



// WEBPACK FOOTER //
// ./js/components/templates/audienceOverview_template.ts